import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/pro-solid-svg-icons'

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Unstable_Grid2';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import BackspaceOutlinedIcon from '@mui/icons-material/BackspaceOutlined';
import LoginIcon from '@mui/icons-material/Login';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import LoadingButton from '@mui/lab/LoadingButton';
import * as apiRoutes from "../config/apiRoutes";
import {getSubmitPreBookedBooking, getTillUser, issueRefund} from "../config/apiRoutes";
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import {getStatus, sendRefund, sendSale, signatureRequest, useDojo} from "../context/dojoContext";
import DojoTerminalSelector from "../components/DojoTerminalSelector";
import DojoTerminalErrorNotifcation from "../components/DojoTerminalErrorNotification";

import {Br, Cashdraw, Cut, Image, Line, Printer, render, Row, Text} from 'react-thermal-printer';
import Modal from "@mui/material/Modal";
import LinearProgress from "@mui/material/LinearProgress";
import QRCode from "qrcode";
import AlertDialog from "../components/AlertDialog";
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import {InputAdornment} from "@mui/material";


library.add(fas);


const cashModalStyle = {
    position: 'absolute',
    bottom: '10%',
    right: '10%',
    //transform: 'translate(-50%, -50%)',
    width:'80%',
    maxWidth: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const cashBtnStyle = {
    p :3,
    width:'100%',
}
const paymentMethodBtnStyle = {
    py:2,
    width:'100%',
}
const auxilaryBtnStyle = {
    py:1,
    width:'100%',
}

export function EposScreen({clearToken, accessToken}) {
    const printerBaudRate = 115200;
    const printerWidth = 48;
    const printerType = 'epson';
    const printerCutLineFeeds = 3;

    const printer = useRef(false);
    const [getReceipt, setReceipt] = useState(false);
    const [printerInitialised, setPrinterInitialised ] = useState(false);

    const inactivityLimit = (1000*60);
    const [userKey, setUserKey] = useState('');
    const [screenProtector, setScreenProtector] = useState(false);
    const [loginInProgress, setLoading] = useState(false);
    const screenProtectorTimeout = useRef(null);
    const screenProtectorLogoTimeout = useRef(null);
    
    const [backgroundImage,setBackgroundImage] = useState('https://pbt.ams3.cdn.digitaloceanspaces.com/assets/backgrounds/' + (Math.floor(Math.random() * (6 - 1) + 1)) + '.jpg');
    const [logoOffsetX, setLogoOffsetX] = useState('50%');
    const [logoOffsetY, setLogoOffsetY] = useState('50%');

    const [tillUser, setTillUser] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [generalLoading, setGeneralLoader] = useState(false);

    const [days, setDays] = useState([]);
    const [trips, setTrips] = useState([]);

    const [tripID, setTripID] = useState(false);
    const [trip, setTrip] = useState(false);


    const journeyTypes = {
        'default' : {
            id: 0,
            name : 'Standard Ticket',
            modifier : '',
        },
        'outbound' : {
            id : 1,
            name : 'Outbound Single Ticket',
            modifier : '_single',
        },
        'return': {
            id : 2,
            name : 'Return Ticket',
            modifier : ''
        },

        'inbound' : {
            id: 3,
            name : 'Inbound Single Ticket',
            modifier : '_single',
        },
    };

    const [journeyType, setJourneyType] = useState(journeyTypes.default);

    const bookingId = useRef(null);

    const [bookingRef, setBookingRef] = useState(null);

    const passengers = useRef(0);
    const bookingManifest = useRef({});
    const [adults, setAdults] = useState(0);
    const [children, setChildren] = useState(0);
    const [toddlers, setToddlers] = useState(0);
    const [families, setFamilies] = useState(0);
    const [vips, setVips] = useState(0);

    const [spectators, setSpectators] = useState(0);
    const [subtotal, setSubtotal] = useState(0);
    const [total, setTotal] = useState(0);

    const [discount, setDiscount] = useState(0);
    const priceBreakdown = useRef({});

    const [rate, setRate] = useState(false);

    const [pricing, setPricing] = useState(false);
    const [tripLoading, setTripLoading] = useState(false);

    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
    const selectedDateRef = useRef(new Date().toISOString().split('T')[0]);
    const [dateString, setDateString] = useState(false);
    const [loadingDay, setLoadingDay] = useState(false);


    const tripRequestInProgress= useRef(false);
    const tripDataRequestInProgress= useRef(false);

    const inactivityTimer = useRef(false);
    const updateDaysTimer = useRef(false);
    const updateTripsTimer = useRef(false);
    const updateBookingTimer = useRef(false);
    const updateBookingInProgress = useRef(false);
    const terminalID = useDojo();

    const paymentsMade = useRef([]);
    const [amountPaid, setAmountPaid] = useState(0);
    const [cashModalOpen, setCashModalOpen] = useState(false);
    const [processingCashPayment, setCashProcessing] = useState(false);
    const [cashReady, setCashReady] = useState(false);
    const [processingBooking, setProcessingBooking] = useState(false);
    const [cardModalOpen, setCardModalOpen] = useState(false);
    const [postBookingModalOpen, setPostBookingModalOpen] = useState(false);
    const [cashProvided, setCashProvided] = useState(0);
    const changeDue = useRef(0);

    const [chequeModalOpen, setChequeModalOpen] = useState(false);
    const [processingChequePayment, setChequeProcessing] = useState(false);
    const [chequeProvided, setChequeProvided] = useState(0);

    const [customRateOpen, setCustomRateOpen] = useState(false);
    const [availableRates, setAvailableRates] = useState([]);
    const [selectedRate, setSelectedRate] = useState(false);

    const [coachDriverOpen, setCoachDriverOpen] = useState(false);
    const [selectedDriver, setSelectedDriver] = useState(false);
    const [coachDrivers, setCoachDrivers] = useState(false);

    const [discountsOpen, setDiscountsOpen] = useState(false);
    const [availableDiscounts, setAvailableDiscounts] = useState(false);
    const [selectedDiscount, setSelectedDiscount] = useState(false);


    const [selectDriverForPayoutModalOpen, setDriverPayoutModal] = useState(false);
    const [payoutDriver, setPayoutDriver] = useState(false);
    const [payoutData, setPayoutData] = useState(false);
    const [payoutAmount, setPayoutAmount] = useState(false);
    const [showPayoutProcessing, setShowPayoutProcessing] = useState(false);

    /** Gift Voucher Variables **/
    const  [showGiftVoucherModal, setShowGiftVoucherModal] = useState(false);
    const [giftVoucherCode, setGiftVoucherCode] = useState(false);
    const [giftVoucher, setGiftVoucher] = useState(false);
    const [giftVouchers, setGiftVouchers] = useState(false);
    const giftVoucherUpdater = useRef(false);

    const cashPadPress = (val) => {
        let newCashProvided = parseInt(parseFloat(cashProvided)*100).toString();

        switch(val) {
            case 'clear' :
                newCashProvided = 0;
                break;
            case 'back' :
                newCashProvided = newCashProvided.slice(0, -1);
                break;
            case 'total' :
                newCashProvided = ((total - amountPaid) * 100).toString()
                break;
            default :
                newCashProvided = newCashProvided + val.toString();
                break;
        }
        if(newCashProvided.length > 0) {
            console.log(newCashProvided);
            newCashProvided = (parseInt(newCashProvided) / 100).toFixed(2);
            console.log(newCashProvided);
        } else  {
            newCashProvided = (0).toFixed(2);
        }

        setCashProvided(newCashProvided);
    }

    const chequePadPress = (val) => {
        let newChequeProvided = parseInt(parseFloat(chequeProvided)*100).toString();

        switch(val) {
            case 'clear' :
                newChequeProvided = 0;
                break;
            case 'back' :
                newChequeProvided = newChequeProvided.slice(0, -1);
                break;
            case 'total' :
                newChequeProvided = ((total - amountPaid) * 100).toString()
                break;
            default :
                newChequeProvided = newChequeProvided + val.toString();
                break;
        }
        if(newChequeProvided.length > 0) {
            console.log(newChequeProvided);
            newChequeProvided = (parseInt(newChequeProvided) / 100).toFixed(2);
            console.log(newChequeProvided);
        } else  {
            newChequeProvided = (0).toFixed(2);
        }

        setChequeProvided(newChequeProvided);
    }


    useEffect(() => {
        if(total >= 0) {
            setCashReady(true);
        } else {
            setCashReady(false);
        }
    },[cashProvided]);

    const logoBase64 = 'data:image/png;base64,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';

    const logoutTillUser = () => {
        console.log('Till User logout');
        setTillUser(false);
        setUserKey('');
        setSelectedDate(new Date().toISOString().split('T')[0])

        setDays([]);
        setTrips([]);
        resetPassengers()
        resetTrip()
        setDateString(false);
        setLoadingDay(false);
        clearTimeout(inactivityTimer.current);
        clearTimeout(updateDaysTimer.current);
        clearTimeout(updateTripsTimer.current);
    }
    const resetPassengers = () => {
        setAdults(0);
        setChildren(0);
        setToddlers(0);
        setFamilies(0);
        setSpectators(0);
        setVips(0);

    }
    const resetTrip = () => {
        setTripID(false);
        setTrip(false);
        setRate(false);
        setPricing(false);
        setJourneyType(journeyTypes.default);
        setSelectedRate(false);
        setSelectedDiscount(false);
        setSelectedDriver(false);
        setDiscount(0);
        setSubtotal(0);
        setTotal(0);
    }

    const resetPayments  = () => {
        paymentsMade.current = [];
        changeDue.current =0
    }
    const cancelBooking = async () => {
        let cancelledSuccessfully = true;
        if(bookingId.current) {
            setGeneralLoader(true);
            var reqHeaders = new Headers();
            reqHeaders.append("Accept", "application/json");
            reqHeaders.append("Authorization", accessToken);

            var formdata = new FormData();

            formdata.append("id", bookingId.current);
            formdata.append("epos_user_key", userKey);

            var requestOptions = {
                method: 'POST',
                headers: reqHeaders,
                body: formdata,
                redirect: 'follow'
            };

            await fetch(apiRoutes.cancelBooking, requestOptions)
                .then(response => {
                    if (!response.ok) {

                    } else {
                        cancelledSuccessfully = false;
                        bookingId.current = null;
                        setSelectedRate(false);
                        setBookingRef(null);
                    }
                });

            setGeneralLoader(false);

        }

        if(cancelledSuccessfully) {
            resetPassengers();
            resetTrip();
            resetPayments();
        }

    }
    const startDaysUpdateTimer = () => {
        clearTimeout(updateDaysTimer.current)

        updateDaysTimer.current = setTimeout(async () => {
            //console.log('auto update of days');
            if(tillUser) {
                await getDays(true);
                startDaysUpdateTimer();
            }
        }, (60 * 60 * 1000))
    }
    const startTripsUpdateTimer = () => {
        clearTimeout(updateTripsTimer.current)

        updateTripsTimer.current = setTimeout(async () => {
            //console.log('auto update of trips : ' + selectedDateRef.current);
            if(tillUser) {
                await getDay(selectedDateRef.current, true);
                startTripsUpdateTimer();
            }
        }, (3 * 1000))
    }
    const startInactivityTimer = () => {
        console.log('auto log out disabled')
        return;

        clearTimeout(inactivityTimer.current)
        //console.log('start incctivity timer');
        inactivityTimer.current = setTimeout(() => {

            logoutTillUser()
        }, inactivityLimit)

    }
    const clearInactivityTimer = () => {
        // console.log('Clear Timeout');
        clearTimeout(inactivityTimer.current)
    }

    const startScreenProtector = () => {
        console.log('screen protector init')
        clearTimeout(screenProtectorTimeout.current);
        clearTimeout(screenProtectorLogoTimeout.current);
        screenProtectorTimeout.current = setTimeout(() => {
            setScreenProtector(true);
            setLogoOffsetY('50%');
            setLogoOffsetX('50%');
            logoOffsetUpdate();

            setBackgroundImage('https://pbt.ams3.cdn.digitaloceanspaces.com/assets/backgrounds/' + (Math.floor(Math.random() * (6 - 1) + 1)) + '.jpg');

        }, (5*60*1000));
    }

    const logoOffsetUpdate = () => {
        screenProtectorLogoTimeout.current = setTimeout(() => {
            setLogoOffsetY(Math.floor(Math.random() * 100) + '%');
            setLogoOffsetX(Math.floor(Math.random() * 100) + '%');
            logoOffsetUpdate();
        }, (10*1000));
    }



    useEffect(() => {
        selectedDateRef.current = selectedDate;
    }, [selectedDate]);
    useEffect(() => {
        if(typeof userKey  == 'string' &&  userKey.length == 4) {
            handleSubmit()
        }
    }, [userKey]);
    useEffect(() => {
        if(tillUser) {
            getDays(true)
            startInactivityTimer();
            startDaysUpdateTimer();
            startTripsUpdateTimer();
        } else {
            logoutTillUser();
            startScreenProtector();
        }

    }, [tillUser]);
    useEffect(() => {
        if(tillUser) {
            getDay(selectedDate, false)
        }
    }, [tillUser,selectedDate]);
    useEffect(() => {
        if(tillUser && tripID) {
            setRate(false);
            setPricing(false);
            setDiscount(0);
            setSubtotal(0);
            setTotal(0);
            getTrip(tripID, false)
        } else  {
            setTrip(false);
        }
    }, [tripID]);
    useEffect(() => {
        let tripPricing  = {...trip.trip_settings};
        console.log(selectedRate);
        console.log(tripPricing);
        if(selectedRate) {
            Object.keys(selectedRate).forEach((key) => {
                // update tripPricing if value is not null and is a 'price' field
                if(selectedRate[key] && key.indexOf('price') !== -1) {
                    tripPricing[key] = selectedRate[key];
                }
            });
        }

        if(journeyType.modifier.length > 0) {
            tripPricing.price_per_adult = tripPricing['price_per_adult' + journeyType.modifier];
            tripPricing.price_per_child = tripPricing['price_per_child' + journeyType.modifier];
            tripPricing.price_per_toddler = tripPricing['price_per_toddler' + journeyType.modifier];
            tripPricing.price_per_family = tripPricing['price_per_family' + journeyType.modifier];
            tripPricing.price_per_vip = tripPricing['price_per_vip' + journeyType.modifier];
            tripPricing.price_per_spectator = tripPricing['price_per_spectator' + journeyType.modifier];
        }

        setPricing(tripPricing);
    }, [trip, journeyType, selectedRate]);
    useEffect(() => {
        if(trip) {
            // console.log(trip);
            calculateTotal();
        }
    }, [
        trip,
        pricing,journeyType, rate,
        adults, children, toddlers, spectators, vips, families,
        selectedDiscount,
        selectedRate,
        selectedDriver
    ]);

    useEffect(() => {
        getCoachDrivers()
    }, [coachDriverOpen, selectDriverForPayoutModalOpen])
    useEffect(() => {
        getDiscounts()
    }, [discountsOpen])

    useEffect(() => {
        if(!payoutDriver) {
            return;
        }
        getPayoutData();

    }, [payoutDriver])

    useEffect(() => {
        if(showGiftVoucherModal) {
            getGiftVouchers();
        }
    }, [
        showGiftVoucherModal
    ]);

    useEffect(() => {
        clearTimeout(giftVoucherUpdater.current);
        giftVoucherUpdater.current = setTimeout(() => {
            getGiftVouchers()
        }, 1000);
    }, [giftVoucherCode]);

    const getGiftVouchers = async () => {
        if(!showGiftVoucherModal) {
            return;
        }
        setGiftVouchers(false);
        let code = giftVoucherCode;

        var reqHeaders = new Headers();
        reqHeaders.append("Accept", "application/json");
        reqHeaders.append("Authorization", accessToken);

        var formdata = new FormData();
        if(giftVoucherCode && giftVoucherCode.length > 2) {
            formdata.append("code", giftVoucherCode);
        }
        formdata.append("epos_user_key", userKey);

        var requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: formdata,
            redirect: 'follow'
        };

        await fetch(apiRoutes.getAvailableGiftVouchers, requestOptions)
            .then(response => {
                if (!response.ok) {
                    setErrorMessage('Error Fetching Gift Vouchers');
                    resetGiftVoucherModal();
                    return false;
                }

                return response.json()
            }).then( result => {
                setGiftVouchers(result.gift_vouchers);
            });

    }
    const resetGiftVoucherModal = () => {
        setGiftVouchers(false)
        setShowGiftVoucherModal(false);
        setGiftVoucherCode();
        setGiftVoucher(false);

    }
    const addGiftVoucher = async (giftVoucherToAdd) => {
        console.log(giftVoucherToAdd);
        paymentsMade.current.push({
            type : 'gift_voucher',
            code : giftVoucherToAdd.code,
            amount: giftVoucherToAdd.amount,
            removable: true,
            gift_voucher_data : giftVoucherToAdd,
            gift_voucher_id : giftVoucherToAdd.id
        });
        resetGiftVoucherModal();
        await updatePaymentStatus();
    }

    const calculateTotal = () => {
        clearTimeout(updateBookingTimer.current);
        if(!trip || !pricing) {
            console.log('no trip | pricing')
            console.log({
                trip : trip,
                pricing : pricing,
            })
            setSubtotal(0);
            setTotal(0);
            return;
        }

        let passengersTotal =  (
            adults +
            children +
            toddlers +
            spectators +
            vips +
            (families * (trip.trip_type.family_size_adults + trip.trip_type.family_size_children))
        );

        bookingManifest.current.passengers = {
            adults : adults,
            children : children,
            toddlers : toddlers,
            spectators : spectators,
            vips : vips,
            families : families,
        };

        passengers.current = passengersTotal;
        if(passengersTotal <= 0) {
            console.log('no passengers')
            setTotal(0);
            return;
        }

        let calcSubtotal = 0;

        calcSubtotal += pricing.price_per_adult * adults;
        calcSubtotal += pricing.price_per_child * children;
        calcSubtotal += pricing.price_per_toddler * toddlers;
        calcSubtotal += pricing.price_per_spectator * spectators;
        calcSubtotal += pricing.price_per_family * families;

        bookingManifest.current.subtotal = calcSubtotal;

        setSubtotal(calcSubtotal);

        console.log(selectedDiscount);


        bookingManifest.current.selectedDiscount  = null;
        bookingManifest.current.selectedDiscountName  = null;
        bookingManifest.current.discount  = 0;
        let discountToApply = 0;
        if(selectedDiscount) {
            bookingManifest.current.selectedDiscount  = selectedDiscount.id;
            bookingManifest.current.selectedDiscountName  = selectedDiscount.name;
            if(selectedDiscount.percentage) {
                discountToApply = bookingManifest.current.discount  = ((calcSubtotal /100) * selectedDiscount.amount) ;

                // run the discount up to the nearest 0.5
                discountToApply = Math.ceil(discountToApply * 2) / 2;

            } else  {
                discountToApply = bookingManifest.current.discount  = selectedDiscount.amount ;
            }
        }

        setDiscount(discountToApply.toFixed(2));


        bookingManifest.current.total = (calcSubtotal - discountToApply);
        setTotal((calcSubtotal - discountToApply));

        clearTimeout(updateBookingTimer.current);

        updateBookingTimer.current = setTimeout(() => {
            console.log('pushingBookingUpdate');
            pushBooking()
        }, 1000*1.5);
    }
    const getDays = async (background) => {
        if(!background) {
            clearInactivityTimer();
        }

        var reqHeaders = new Headers();
        reqHeaders.append("Accept", "application/json");
        reqHeaders.append("Authorization", accessToken);

        var formdata = new FormData();
        formdata.append("user_key", userKey);

        var requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: formdata,
            redirect: 'follow'
        };

        await fetch(apiRoutes.getDays, requestOptions)
            .then(response => {
                if(!response.ok) {
                    setErrorMessage(response.statusText);
                    return false;
                }
                return response.json()
            })
            .then(result => {
                //  console.log(result)
                if(result) {
                    setDays(result.tripsByDay);
                }
            })
            .catch(error => {
                console.log('error', error);
                setErrorMessage(error.toString());
            });
        if(!background) {
            startInactivityTimer()
        }
    }
    const getDay = async (date, background) => {
        if(tripRequestInProgress.current) {
            console.log('request in progress');
            return;
        }
        if(!background) {
            clearTimeout(updateTripsTimer.current)
            clearInactivityTimer();
            setLoadingDay(true)
        }
        tripRequestInProgress.current = true;
        //console.log('fetching day  : ' + date);
        var reqHeaders = new Headers();
        reqHeaders.append("Accept", "application/json");
        reqHeaders.append("Authorization", accessToken);

        var formdata = new FormData();
        formdata.append("user_key", userKey);

        var requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: formdata,
            redirect: 'follow'
        };

        await fetch(apiRoutes.getDay + '?date=' + date, requestOptions)
            .then(response => {
                if(!response.ok) {
                    setErrorMessage(response.statusText);
                    return false;
                }
                return response.json()
            })
            .then(result => {
                // console.log('trips fetch')
                // console.log(result)

                setTrips(result.trips);
                setDateString(result.dateNice);
            })
            .catch(error => {
                console.log('error', error);
                setErrorMessage(error.toString());
            });
        tripRequestInProgress.current = false;
        if(!background) {
            startTripsUpdateTimer();
            startInactivityTimer()
            setLoadingDay(false)
        }
    }
    const getTrip = async (id,background) => {
        if(tripDataRequestInProgress.current) {
            console.log('trip request in progress');
            return;
        }

        if(!background) {
            setTripLoading(true);
        }

        tripDataRequestInProgress.current = true;

        console.log('fetching trip  : ' + id);
        var reqHeaders = new Headers();
        reqHeaders.append("Accept", "application/json");
        reqHeaders.append("Authorization", accessToken);

        var formdata = new FormData();
        formdata.append("user_key", userKey);

        var requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: formdata,
            redirect: 'follow'
        };

        await fetch(apiRoutes.getTrip + '?id=' + id, requestOptions)
            .then(response => {
                if(!response.ok) {
                    setErrorMessage(response.statusText);
                    return false;
                }
                return response.json()
            })
            .then(result => {
                console.log('trip fetch')
                console.log(result)
                setTrip(result.trip);

                if(result.trip.trip_type.ferry_service) {
                    if(journeyType.id == journeyTypes.default.id) {
                        setJourneyType(journeyTypes.return);
                    }
                } else  {
                    setJourneyType(journeyTypes.default);
                }

                try {
                    setAvailableRates(result.trip.trip_type.active_custom_trip_rates);
                    if(selectedRate) {
                        let rateFound = false;
                        result.trip.trip_type.active_custom_trip_rates.forEach((rate) => {
                            if(rate.id == selectedRate.id) {
                                rateFound = true;
                            }
                        });
                        if(!rateFound) {
                            setSelectedRate(false);
                        }
                    }
                } catch (e) {
                    console.log(e);
                    setAvailableRates([]);
                }

            })
            .catch(error => {
                console.log('error', error);
                setErrorMessage(error.toString());
            });
        tripRequestInProgress.current = false;


        tripDataRequestInProgress.current = false;


        if(!background) {
            setTripLoading(false);
        }

    }
    const backSpace = () => {
        if(typeof userKey  == 'string' &&  userKey.length) {
            let newKey = userKey.slice(0, -1);
            if(newKey.length == 0 ) {
                newKey = null;
                setUserKey(newKey)
            }else if(newKey.length == 4 ) {
                setUserKey(newKey)
                handleSubmit()
            } else {
                setUserKey(newKey)
            }
        }
    }
    const keyPress = (key) => {
        let newKey = (userKey ? userKey.toString() : '') + key.toString();
        if(newKey.length <= 4) {
            setUserKey(newKey)
        }
    }
    const clearCode = () => {
        setUserKey(null)
    }
    const clearTillUser = () => {
        setTillUser(null)
    }
    const handleSubmit = async (e) => {

        console.log(userKey);
        console.log(accessToken);
        if(typeof userKey  == 'string' &&  userKey.length === 4) {
            setLoading(true);
            var reqHeaders = new Headers();
            reqHeaders.append("Accept", "application/json");
            reqHeaders.append("Authorization", accessToken);

            var formdata = new FormData();
            formdata.append("user_key", userKey);

            var requestOptions = {
                method: 'POST',
                headers: reqHeaders,
                body: formdata,
                redirect: 'follow'
            };

            await fetch(getTillUser, requestOptions)
                .then(response => {
                    if(!response.ok) {
                        setErrorMessage(response.statusText);
                        return false;
                    }
                    return response.json()
                })
                .then(result => {
                    console.log(result)
                    setTillUser(result.tillUser);
                })
                .catch(error => {
                    console.log('error', error);
                    setErrorMessage(error.toString());
                });

            setLoading(false);

        }
    }
    const TripInfo = ({tripData}) => {
        if (!tripData) {
            return (<Box p={2} sx={{textAlign:'center', backgroundColor: 'warning.dark', color: '#ffffff'}}>
                <Typography sx={{fontSize:25}} variant={'h6'}>No trip selected</Typography>
            </Box>)

        }

        return (
            <Box p={1} pt={1} sx={{textAlign:'center', backgroundColor: 'primary.dark', borderTopWidth: 10, borderTopStyle:'solid', borderColor: trip.trip_color, color: '#ffffff'}}>
                <Typography sx={{fontSize:10}} variant={'h6'}>{trip.trip_title} - {trip.boat_name}</Typography>
                <Grid container justifyContent={'space-between'} >
                    <Grid xs={'auto'}>
                        <Typography sx={{fontSize:10}}>{trip.depart_time_nice} - {trip.arrival_time_nice}</Typography>

                    </Grid>
                    <Grid xs={'auto'}>
                        <Typography sx={{fontSize:10}}>
                            {trip.shortDay} {trip.niceDate}
                        </Typography>
                    </Grid>

                    <Grid xs={'auto'}>
                        <Typography sx={{fontSize:10}}>{trip.depart_location} - {trip.arrival_location}</Typography>
                    </Grid>
                </Grid>

            </Box>
        );
    }
    const pushBooking = async () => {
        setErrorMessage(null);
        console.log(passengers.current);

        if(updateBookingInProgress.current) {
            clearTimeout(updateBookingTimer.current);

            updateBookingTimer.current = setTimeout(() => {
                console.log('pushingBookingUpdate');
                pushBooking()
            }, 1000*3);
            return;
        }

        updateBookingInProgress.current =true;
        setGeneralLoader(true);

        if(passengers.current <= 0 || !tripID ) {
            console.log('passengers or trip missing no need to update')
            updateBookingInProgress.current =true;
            return;
        }
        var reqHeaders = new Headers();
        reqHeaders.append("Accept", "application/json");
        reqHeaders.append("Authorization", accessToken);

        var formdata = new FormData();
        if(bookingId.current) {
            formdata.append("id", bookingId.current);
        }
        formdata.append("trip_id", tripID);
        formdata.append("journey_type", journeyType.id);
        formdata.append("num_adults", bookingManifest.current.passengers.adults);
        formdata.append("num_children", bookingManifest.current.passengers.children);
        formdata.append("num_toddlers", bookingManifest.current.passengers.toddlers);
        formdata.append("num_families", bookingManifest.current.passengers.families);
        formdata.append("num_vips", bookingManifest.current.passengers.vips);
        formdata.append("num_spectators", bookingManifest.current.passengers.spectators);
        formdata.append("num_passengers", passengers.current);
        formdata.append("base_price", bookingManifest.current.subtotal);
        formdata.append("total_price", bookingManifest.current.total);
        formdata.append("price_breakdown", JSON.stringify(priceBreakdown.current));
        formdata.append("discount_id", bookingManifest.current.selectedDiscount);
        formdata.append("discount_applied", bookingManifest.current.discount);
        formdata.append("private_notes", 'Ticket Hut Booking - ' + userKey );
        formdata.append("epos_user_key", userKey);

        if(selectedRate) {
            console.log(selectedRate)
            formdata.append("custom_trip_rate_id", selectedRate.id);
        } else {
            formdata.append("custom_trip_rate_id", '');
        }
        if(selectedDriver) {
            console.log(selectedDriver)
            formdata.append("coach_driver_id", selectedDriver.id);
        } else {
            formdata.append("coach_driver_id", '');
        }

        var requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: formdata,
            redirect: 'follow'
        };

        await fetch(apiRoutes.createBooking, requestOptions)
            .then(response => {
                if(!response.ok) {
                    setErrorMessage('Error updating Booking - Bad Response')
                    return false;
                }

                return response.json()
            }).then(json => {
                bookingId.current = json.booking.id
                setBookingRef(json.booking.booking_ref);
            });
        setGeneralLoader(false);
        updateBookingInProgress.current = false
    }
    const sendToPrinter = async (data, save) => {

        let printData = await render(data);

        if(save !== undefined && save) {
            setReceipt(printData);
        }

        return await sendRawDataToPrinter(printData);

    }
    const sendRawDataToPrinter = async (data) => {
        if(printer.current === false) {
            console.log(printer.current);
            try {
                printer.current = await window.navigator.serial.requestPort();
            } catch(e) {
                alert('Print failed (please select a COM PORT Device) #P000');
                return false;
            }
        }

        if(!printer.current) {
            alert('Print failed (please select a COM PORT Device) #P001');
            return false;
        }

        try {
            await printer.current.open({baudRate: printerBaudRate});
        } catch (e) {
            alert('Print failed #P002');
            return false;
        }

        let writer = null;
        let result = false;
        try {
            if(printer.current.writable) {
                writer = printer.current.writable.getWriter();
                await writer.write(data);
                writer.releaseLock();
                result = true;
            }
        } catch (e) {
            alert('Print failed #P003');
            return false;
        }
        try {
            await printer.current.close();
        } catch (e) {
            console.log('could not close port connection');
        }

        return result;
    }
    const printHeader = () => {
        return (
            <>
                <Br/>
                <Cut lineFeeds={printerCutLineFeeds} />
                <Br/>
                <Br/>
                <Text align={'center'} >Plymouth Boat Trips</Text>
                <Br/>
                <Line/>
                <Br/>
            </>
        )
    }
    const printFooter = () => {
        const currentDateTime = new Date();
        return (
            <>
                <Br/>
                <Text
                    align={'center'}  size={{ width: 1, height: 1 }}>
                    Booking Ref : {bookingRef}
                </Text>
                <Row
                    left={currentDateTime.toLocaleDateString()}
                    right={([
                        currentDateTime.getHours().toString().padStart(2, '0'),
                        currentDateTime.getMinutes().toString().padStart(2,'0'),
                    ]).join(':')}
                />


                <Line/>
                <Br/>

                <Text align={'center'}  size={{ width: 1, height: 1 }}>
                    Plymouth Boat Trips, 2-5 Commercial Wharf,
                </Text>
                <Text align={'center'}  size={{ width: 1, height: 1 }}>
                    Barbican, Plymouth, Devon, PL1 2NX
                </Text>
                <Text align={'center'}  size={{ width: 1, height: 1 }}>
                    www.plymouthboattrips.co.uk
                </Text>
                <Text align={'center'}  size={{ width: 1, height: 1 }}>
                    Reg Company Number : 6554970
                </Text>
                <Text align={'center'}  size={{ width: 1, height: 1 }}>
                    VAT No : 807668793
                </Text>
                <Line/>
                <Br/>
                <Text align={'center'}  size={{ width: 1, height: 1 }}>Welcome Aboard!</Text>
                <Br/>
                <Line/>
                <Br/> <Br/>

            </>
        )
    }
    const printQRCode = async () => {
        let qrCodeDataUrl = await QRCode.toDataURL(
            bookingId.current,
            { errorCorrectionLevel: 'H', width:400 }
        );

        return (
            <Image align="center"  src={qrCodeDataUrl} />
        );
    }

    const printBoardingPasses = async () => {

        let adultBoardingCards = null;
        let childBoardingCards = null;
        let toddlerBoardingCards = null;
        let vipBoardingCards = null;
        let spectatorBoardingCards = null;
        let familyBoardingCards = null;
        let qrCodeDataUrl = null;

        if (adults > 0) {
            qrCodeDataUrl = await QRCode.toDataURL(
                'INDIVIDUAL_ADULT-' + bookingId.current,
                { errorCorrectionLevel: 'H', width:400 }
            );
            //render a board pass for each adult
            adultBoardingCards = (
                <>
                    {Array(adults).fill(0).map((_, index) => {

                            return (
                                <>
                                    <Br/>
                                    <Cut lineFeeds={printerCutLineFeeds}/>
                                    <Br/>
                                    <Br/>
                                    <Text align={'center'}>Plymouth Boat Trips</Text>
                                    <Br/>
                                    <Line/>

                                    <Text align={"center"}>{trip.trip_title}</Text>
                                    <Text align={"center"}>{trip.boat_name}</Text>
                                    <Text
                                        align={"center"}>{trip.niceDate} - {trip.depart_time_nice} - {trip.arrival_time_nice}</Text>
                                    <Text align={"center"}>{trip.depart_location} - {trip.arrival_location}</Text>
                                    <Text align={"center"}>{journeyType.name}</Text>
                                    <Text align={"center"} bold={true} style={{width:2,height:2}}>{'ADULT TICKET'}</Text>
                                    <Br/>
                                    <Image align="center"  src={qrCodeDataUrl} />
                                    <Line/>
                                </>
                            );
                        }
                    )
                    }
                </>
            );
        }

        if (children > 0) {
            qrCodeDataUrl = await QRCode.toDataURL(
                'INDIVIDUAL_CHILD-' + bookingId.current,
                { errorCorrectionLevel: 'H', width:400 }
            );
            //render a board pass for each adult
            childBoardingCards = (
                <>
                    {Array(children).fill(0).map((_, index) => {

                            return (
                                <>
                                    <Br/>
                                    <Cut lineFeeds={printerCutLineFeeds}/>
                                    <Br/>
                                    <Br/>
                                    <Text align={'center'}>Plymouth Boat Trips</Text>
                                    <Br/>
                                    <Line/>

                                    <Text align={"center"}>{trip.trip_title}</Text>
                                    <Text align={"center"}>{trip.boat_name}</Text>
                                    <Text
                                        align={"center"}>{trip.niceDate} - {trip.depart_time_nice} - {trip.arrival_time_nice}</Text>
                                    <Text align={"center"}>{trip.depart_location} - {trip.arrival_location}</Text>
                                    <Text align={"center"}>{journeyType.name}</Text>
                                    <Text align={"center"} bold={true} style={{width:2,height:2}}>{'CHILD TICKET'}</Text>
                                    <Br/>
                                    <Image align="center"  src={qrCodeDataUrl} />
                                    <Line/>
                                </>
                            );
                        }
                    )
                    }
                </>
            );
        }

        if (toddlers > 0) {
            qrCodeDataUrl = await QRCode.toDataURL(
                'INDIVIDUAL_TODDLER-' + bookingId.current,
                { errorCorrectionLevel: 'H', width:400 }
            );
            //render a board pass for each adult
            toddlerBoardingCards = (
                <>
                    {Array(toddlers).fill(0).map((_, index) => {

                            return (
                                <>
                                    <Br/>
                                    <Cut lineFeeds={printerCutLineFeeds}/>
                                    <Br/>
                                    <Br/>
                                    <Text align={'center'}>Plymouth Boat Trips</Text>
                                    <Br/>
                                    <Line/>

                                    <Text align={"center"}>{trip.trip_title}</Text>
                                    <Text align={"center"}>{trip.boat_name}</Text>
                                    <Text
                                        align={"center"}>{trip.niceDate} - {trip.depart_time_nice} - {trip.arrival_time_nice}</Text>
                                    <Text align={"center"}>{trip.depart_location} - {trip.arrival_location}</Text>
                                    <Text align={"center"}>{journeyType.name}</Text>
                                    <Text align={"center"} bold={true} style={{width:2,height:2}}>{'TODDLER TICKET'}</Text>
                                    <Br/>
                                    <Image align="center"  src={qrCodeDataUrl} />
                                    <Line/>
                                </>
                            );
                        }
                    )
                    }
                </>
            );
        }

        if (spectators > 0) {
            qrCodeDataUrl = await QRCode.toDataURL(
                'INDIVIDUAL_SPECTATOR-' + bookingId.current,
                { errorCorrectionLevel: 'H', width:400 }
            );
            //render a board pass for each adult
            spectatorBoardingCards = (
                <>
                    {Array(spectators).fill(0).map((_, index) => {

                            return (
                                <>
                                    <Br/>
                                    <Cut lineFeeds={printerCutLineFeeds}/>
                                    <Br/>
                                    <Br/>
                                    <Text align={'center'}>Plymouth Boat Trips</Text>
                                    <Br/>
                                    <Line/>

                                    <Text align={"center"}>{trip.trip_title}</Text>
                                    <Text align={"center"}>{trip.boat_name}</Text>
                                    <Text
                                        align={"center"}>{trip.niceDate} - {trip.depart_time_nice} - {trip.arrival_time_nice}</Text>
                                    <Text align={"center"}>{trip.depart_location} - {trip.arrival_location}</Text>
                                    <Text align={"center"}>{journeyType.name}</Text>
                                    <Text align={"center"} bold={true} style={{width:2,height:2}}>{'SPECTATOR TICKET'}</Text>
                                    <Br/>
                                    <Image align="center"  src={qrCodeDataUrl} />
                                    <Line/>
                                </>
                            );
                        }
                    )
                    }
                </>
            );
        }

        if (families > 0) {
            let qrCodeDataUrl = await QRCode.toDataURL(
                'INDIVIDUAL_FAMILY-' + bookingId.current,
                { errorCorrectionLevel: 'H', width:400 }
            );
            //render a board pass for each adult
            familyBoardingCards = (
                <>
                    {Array(families).fill(0).map((_, index) => {

                            return (
                                <>
                                    <Br/>
                                    <Cut lineFeeds={printerCutLineFeeds}/>
                                    <Br/>
                                    <Br/>
                                    <Text align={'center'}>Plymouth Boat Trips</Text>
                                    <Br/>
                                    <Line/>

                                    <Text align={"center"}>{trip.trip_title}</Text>
                                    <Text align={"center"}>{trip.boat_name}</Text>
                                    <Text
                                        align={"center"}>{trip.niceDate} - {trip.depart_time_nice} - {trip.arrival_time_nice}</Text>
                                    <Text align={"center"}>{trip.depart_location} - {trip.arrival_location}</Text>
                                    <Text align={"center"}>{journeyType.name}</Text>
                                    <Text align={"center"} bold={true} style={{width:2,height:2}}>{'FAMILY TICKET'}</Text>
                                    <Br/>
                                    <Image align="center"  src={qrCodeDataUrl} />
                                    <Line/>
                                </>
                            );
                        }
                    )
                    }
                </>
            );
        }

        if (vips > 0) {
            qrCodeDataUrl = await QRCode.toDataURL(
                'INDIVIDUAL_VIP-' + bookingId.current,
                { errorCorrectionLevel: 'H', width:400 }
            );
            //render a board pass for each adult
            vipBoardingCards = (
                <>
                    {Array(vips).fill(0).map((_, index) => {

                            return (
                                <>
                                    <Br/>
                                    <Cut lineFeeds={printerCutLineFeeds}/>
                                    <Br/>
                                    <Br/>
                                    <Text align={'center'}>Plymouth Boat Trips</Text>
                                    <Br/>
                                    <Line/>
                                    <Text align={"center"}>{trip.trip_title}</Text>
                                    <Text align={"center"}>{trip.boat_name}</Text>
                                    <Text align={"center"}>{trip.niceDate} - {trip.depart_time_nice} - {trip.arrival_time_nice}</Text>
                                    <Text align={"center"}>{trip.depart_location} - {trip.arrival_location}</Text>
                                    <Text align={"center"}>{journeyType.name}</Text>
                                    <Text align={"center"} bold={true} style={{width:2,height:2}}>{'VIP TICKET'}</Text>
                                    <Br/>
                                    <Image align="center"  src={qrCodeDataUrl} />
                                    <Line/>
                                </>
                            );
                        }
                    )
                    }
                </>
            );
        }

        return (
            <>
                {adultBoardingCards}
                {childBoardingCards}
                {toddlerBoardingCards}
                {familyBoardingCards}
                {vipBoardingCards}
                {spectatorBoardingCards}
            </>
        )
    }

    const initialisePrinter = async () => {
        const header = await printHeader();
        const initialPrint = (
            <Printer type={printerType} width={printerWidth} >
                <Br/>
                <Br/>
                <Line character={'/'}/>
                <Line character={'\\'}/>
                {header}
                <Br/>
            </Printer>
        )


        let printResult = await sendToPrinter(initialPrint, false);

        if(printResult) {
            setPrinterInitialised(true);
        }
    }
    const reprintReceipt = async () => {
        if(!printerInitialised) {
            await initialisePrinter();
        }
        await sendRawDataToPrinter(getReceipt, false);

    }

    const PaymentRows = async () => {
        if(paymentsMade.current.length === 0) {
            return null;
        }

        return (
            <>
                {
                    paymentsMade.current.map(
                        (p, index) => {
                            let paymentName = p.type.charAt(0).toUpperCase() + p.type.slice(1).replaceAll('_', ' ');
                            if(p.code !== undefined) {
                                paymentName += ' - ' + p.code ;
                            }
                            return (
                                <Row left={'     ' + paymentName} right={'£' + p.amount.toFixed(2)}/>
                            )
                        }
                    )
                }
            </>

        )
    }

    const getCardPaymentDetails = async () => {

        let cardPaymentData = [];

        const targetKeys = [
            {
                title: 'TID',
                key : 'transactionId',
            },
            {
                title: 'Type',
                key : 'cardSchemeName',
            },
            {
                title: 'Number',
                key : 'primaryAccountNumber',
            },
            {
                title: 'AID',
                key : 'applicationId',
            },
            {
                title: 'PAN Seq. no',
                key : 'primaryAccountNumberSequence',
            },
            {
                title: 'Auth. Code',
                key : 'authCode',
            },
        ]
        paymentsMade.current.map(
            (p, index) => {
                if (p.type == 'card') {
                    let transactionDataPresent = true;
                    try {
                        if (Object.keys(p.transactionData).length === 0) {
                            transactionDataPresent = false;
                        }
                    } catch (e) {
                        transactionDataPresent = false;
                    }
                    if(transactionDataPresent) {
                        targetKeys.map(
                            (t, index) => {
                                let value = p.transactionData.transactionStatus.data[t.key] ?? null;
                                if(value) {
                                    cardPaymentData.push({
                                        title : t.title,
                                        value : value,
                                    })
                                }
                            }
                        );
                    }
                }
            }
        );

        return cardPaymentData;
    }

    const printReceipt = async () => {
        if(!printerInitialised) {
            await initialisePrinter();
        }
        const qrCodeContent = await printQRCode();
        const footer = await printFooter();
        const header = await printHeader();
        const payments = await PaymentRows();
        const cardPayments = await getCardPaymentDetails();

        const passengerBoardingPasses = await printBoardingPasses();


        const receipt = await (
            <Printer type={printerType} width={printerWidth} >
                <Br/>
                {adults > 0 ? (<Row left={adults + ' x Adult'} right={'£' + (pricing.price_per_adult * adults).toFixed(2)}/>) : null}
                {children > 0 ? (<Row left={children + ' x Child'} right={'£' + (pricing.price_per_child * children).toFixed(2)}/>) : null}
                {toddlers > 0 ? (<Row left={toddlers + ' x Toddler'} right={'£' + (pricing.price_per_toddler * toddlers).toFixed(2)}/>) : null}
                {spectators > 0 ? (<Row left={spectators + ' x Spectator'} right={'£' + (pricing.price_per_spectator * spectators).toFixed(2)}/>) : null}
                {vips > 0 ? (<Row left={vips + ' x VIP'} right={'£' + (pricing.price_per_vip * vips).toFixed(2)}/>) : null}
                {families > 0 ? (<Row left={families + ' x Family'} right={'£' + (pricing.price_per_family * families).toFixed(2)}/>) : null}

                <Line />
                <Row left={'Subtotal'} right={'£' + subtotal.toFixed(2)}/>
                {discount > 0 ? (<Row left={'Discount ' + (selectedDiscount.name ?? '')} right={'-£' + discount}/>) : null}
                <Line />
                <Line />
                <Row left={'Total'} right={'£' + total.toFixed(2)}/>
                {payments}
                { changeDue.current >  0  ? <Row left={'Change'} right={'£' + changeDue.current.toFixed(2)}/> : null }
                <Line />
                {cardPayments.map((cardPayment, index) => (
                    <Row key={index} left={cardPayment.title} right={cardPayment.value} />
                ))}
                <Line />
                {selectedRate !== false ? (<Row left={'Rate'} right={selectedRate.name }/>) : null}
                <Text align={"center"}>{trip.trip_title}</Text>
                <Text align={"center"}>{trip.boat_name}</Text>
                <Text align={"center"}>{trip.niceDate} - {trip.depart_time_nice} - {trip.arrival_time_nice}</Text>
                <Text align={"center"}>{trip.depart_location} - {trip.arrival_location}</Text>
                <Text align={"center"}>{journeyType.name}</Text>
                <Line />
                {/*{qrCodeContent} - 2024 - removed to be replaced with individual boarding passes :) */}
                {footer}
                <Cashdraw pin="2pin" />
                {passengerBoardingPasses}

                {header}
            </Printer>
        );

        await sendToPrinter(receipt, true);

    }

    const openCashDraw = async () => {
        const receipt = await (
            <Printer type={printerType} width={printerWidth} >
                <Cashdraw pin="2pin" />
            </Printer>
        );

        if(window.confirm('Are you sure you want to open the cash draw?')) {
            await sendToPrinter(receipt, false);
        }

    }

    const payCash = async () =>  {
        setCashModalOpen(true);
    }

    const removePayment = async (index) => {
        paymentsMade.current.splice(index, 1);
        updatePaymentStatus();
    }

    const payCashComplete = async () => {
        setCashProcessing(true);
        const cashProvidedFloat = parseFloat(cashProvided);

        paymentsMade.current.push({
            type : 'cash',
            amount : cashProvidedFloat,
            removable: true,
        });
        // calcAmountPaid
        // amountPaid
        setCashProvided(0);
        updatePaymentStatus();
        setCashModalOpen(false);
        setCashProcessing(false);
    }

    const payCard = async () => {
        setCardModalOpen(true)
        startTransactionCycle();

    }

    const payCardComplete = async (paymentDetails, cardTotal) => {
        console.log(paymentDetails);

        paymentsMade.current.push({
            type : 'card',
            amount : cardTotal,
            removable: false,
            transactionData : paymentDetails,
        });

        setCardModalOpen(false);
        await updatePaymentStatus();
        clearCardPaymentVariables();
    }

    const clearCardPaymentVariables = () => {
        setCardPaymentLog([]);
        setTransactionData('-');
        setTransactionID(null);
        transactionStarted.current = false;
        clearTimeout(terminalTimer.current);
        transactionLocation.current = null;
        setTransactionResult(null);
        setLogBg('black');

    }

    const payCheque = async () => {
        setChequeModalOpen(true);
    }
    const payChequeComplete = async () => {
        setChequeProcessing(true);
        const chequeProvidedFloat = parseFloat(chequeProvided);

        paymentsMade.current.push({
            type : 'cheque',
            amount : chequeProvidedFloat,
            removable: true,
        });
        // calcAmountPaid
        // amountPaid
        setChequeProvided(0);
        updatePaymentStatus();
        setChequeModalOpen(false);
        setChequeProcessing(false);
    }


    /**
     * Gift Voucher Creator Functionality
     */
    const newGiftVoucherTerminalDataDefaultState = {
        started : false,
        location: null,
        transactionID : null,
        transactionNumber : null,
        transactionStatus : null,
        transactionLog : [],
        transactionStatusLog : [],
    }
    const [showGiftVoucherCreatorModal, setShowGiftVoucherCreatorModal] = useState(false);
    const [newGiftVoucherAmount, setNewGiftVoucherAmount] = useState(0);
    const [newGiftVoucherProcessing, setNewGiftVoucherProcessing] = useState(false);
    const [newGiftVoucherError, setNewGiftVoucherError] = useState(false);
    const [newGiftVoucherComplete, setNewGiftVoucherComplete] = useState(false);
    const [newGiftVoucher, setNewGiftVoucher] = useState(false);
    const [newGiftVoucherPaymentMethod, setNewGiftVoucherPaymentMethod] = useState('card');
    const newGiftVoucherTerminalData = useRef(newGiftVoucherTerminalDataDefaultState);
    const newGiftVoucherTerminalTimer = useRef(false);
    const [newGiftVoucherTerminalLog, setNewGiftVoucherTerminalLog] = useState([]);
    const [newGiftVoucherTransactionResult, setNewGiftVoucherTransactionResult] = useState([]);

    const createGiftVoucher = () => {
        setShowGiftVoucherCreatorModal(true);

    }

    const resetGiftVoucherCreator = () => {
        setShowGiftVoucherCreatorModal(false);
        setNewGiftVoucherAmount(0);
        setNewGiftVoucherPaymentMethod('card');
        setNewGiftVoucherProcessing(false);
        setNewGiftVoucherError(false);
        setNewGiftVoucherComplete(false);
        setNewGiftVoucher(false);
        setNewGiftVoucherTerminalLog([]);
        setNewGiftVoucherTransactionResult(null);
        newGiftVoucherTerminalData.current = newGiftVoucherTerminalDataDefaultState
    }

    const prepareNewGiftVoucherTransaction = () => {

        setNewGiftVoucherError(false);
        setNewGiftVoucherComplete(false);
        setNewGiftVoucher(false);
        setNewGiftVoucherTerminalLog([]);
        setNewGiftVoucherTransactionResult(null);
        newGiftVoucherTerminalData.current = newGiftVoucherTerminalDataDefaultState;

    }

    const processNewGiftCardRequest = async () => {
        setNewGiftVoucherProcessing(true);

        await prepareNewGiftVoucherTransaction();


        if(newGiftVoucherPaymentMethod == 'cash') {
            await generateGiftCard('cash', null)
        } else  {

            startNewGiftVoucherCardTransaction()
        }

    }

    const startNewGiftVoucherCardTransaction = () => {
        if(!newGiftVoucherTerminalData.current.started) {
            newGiftVoucherTerminalData.current.started = true;
            let transactionStartupLog = [];
            transactionStartupLog.push(new Date().toISOString());
            transactionStartupLog.push('Starting card transaction');
            if(!terminalID) {
                transactionStartupLog.push('No Terminal Selected');
                setNewGiftVoucherError('No Terminal Selected');
                newGiftVoucherTerminalData.current.transactionLog = transactionStartupLog;
                setNewGiftVoucherTerminalLog(newGiftVoucherTerminalDataDefaultState.current.transactionLog);
                setNewGiftVoucherProcessing(false);
                return;
            }
            transactionStartupLog.push('Terminal ID : ' + terminalID);
            newGiftVoucherTerminalData.current.transactionLog = transactionStartupLog;
            setNewGiftVoucherTerminalLog(newGiftVoucherTerminalData.current.transactionLog);
            sendGiftVoucherPaymentToTerminal()
        }
    }
    const sendGiftVoucherPaymentToTerminal = async () => {
        let transactionLog = [];

        let response = await sendSale({
            amount : newGiftVoucherAmount,
            terminalID: terminalID
        });

        if(response.status.ok) {
            beginGiftVoucherTransactionChecks(response.data.location);
        } else  {
            let message = '';
            message += response.data.userMessage ?? '';
            message += response.status.text ?? '';
            message += ' : ';
            message += response.status.code;
            transactionLog.push(message);
        }
        newGiftVoucherTerminalData.current.transactionLog = [...newGiftVoucherTerminalData.current.transactionLog, ...transactionLog]
        setNewGiftVoucherTerminalLog(newGiftVoucherTerminalData.current.transactionLog);
        console.log(response)

    }

    const beginGiftVoucherTransactionChecks = async (location) => {
        newGiftVoucherTerminalData.current.location = location;
        checkGiftVoucherTransaction();
    }

    const checkGiftVoucherTransaction = async () => {
        clearTimeout(newGiftVoucherTerminalTimer.current);
        let transactionLog = [];
        const transactionStatus = await getStatus({
            location: newGiftVoucherTerminalData.current.location,
        });

        let transactionFinished = false;
        console.log(newGiftVoucherTerminalData.current.location);
        console.log(transactionStatus);

        if (transactionStatus.status.ok) {
            transactionLog = transactionStatus.data.notifications;
            newGiftVoucherTerminalData.current.transactionStatus = transactionStatus;
            newGiftVoucherTerminalData.current.transactionID = (transactionStatus.data.transactionId ?? null);
            newGiftVoucherTerminalData.current.transactionNumber = (transactionStatus.data.transactionNumber ?? null);


            if (transactionStatus.data.notifications[0] == 'TRANSACTION_FINISHED') {
                transactionFinished = true;
                transactionLog.push(transactionStatus.data.userMessage);
                if (transactionStatus.data.transactionResult === 'SUCCESSFUL') {
                    newGiftVoucherTransactionSuccessful();
                } else if(transactionStatus.data.transactionResult === 'TIMED_OUT') {
                    newGiftVoucherTransactionTimedOut();
                } else {
                    newGiftVoucherTransactionFailed();
                }
            } else if(transactionStatus.data.notifications[0] == 'SIGNATURE_VERIFICATION') {
                newGiftVoucherTransactionRequiresSignature();
            } else  {
                console.log(transactionStatus.data.notifications[0])
            }
        }


        if (!transactionFinished) {
            newGiftVoucherTerminalTimer.current = setTimeout(() => {
                console.log('firing GV recheck');
                checkGiftVoucherTransaction()
            }, 1000)
        }
        newGiftVoucherTerminalData.current.transactionLog = newGiftVoucherTerminalData.current.transactionLog
        newGiftVoucherTerminalData.current.transactionStatusLog = transactionLog.reverse()
        setNewGiftVoucherTerminalLog([...newGiftVoucherTerminalData.current.transactionLog, ...newGiftVoucherTerminalData.current.transactionStatusLog])
    }

    const newGiftVoucherTransactionSuccessful = async () => {
        await generateGiftCard('card', newGiftVoucherTerminalData.current.transactionStatus);
    }

    const newGiftVoucherTransactionFailed = () => {
        setNewGiftVoucherTransactionResult(null);
        setNewGiftVoucherComplete(false);
        setNewGiftVoucherProcessing(false);
        setNewGiftVoucherError('Transaction Failed : ' + newGiftVoucherTerminalData.current.transactionStatus.data.transactionResult );
    }

    const newGiftVoucherTransactionTimedOut = () => {
        setNewGiftVoucherTransactionResult(() => (
            <>
                <Button
                    fullWidth={true}
                    variant={'contained'}
                    color={'success'}
                    size={'large'}
                    sx={{width:'100%', padding:3, marginBottom:2}}

                    onClick={() => {
                        newGiftVoucherTransactionSuccessful();
                    }}>
                    Transaction Successful
                </Button>
                <Button
                    fullWidth={true}
                    variant={'contained'}
                    color={'error'}
                    size={'large'}
                    sx={{width:'100%', padding:3, marginBottom:2}}

                    onClick={() => {
                        newGiftVoucherTransactionFailed();
                    }}>
                    Transaction Failed
                </Button>
            </>
        ))
    }

    const newGiftVoucherTransactionRequiresSignature = () => {
        setNewGiftVoucherTransactionResult(() => (
            <>
                <Button
                    variant={'contained'}
                    color={'error'}
                    size={'large'}
                    sx={{width:'100%', padding:3, marginBottom:2,}}

                    onClick={
                        async () => {
                            let  verifyResult =  await signatureRequest({
                                location : newGiftVoucherTerminalData.current.location,
                                terminalID : terminalID,
                                accepted: false});
                            setNewGiftVoucherTerminalLog([...newGiftVoucherTerminalLog, ...[verifyResult.status.ok ? 'Signature request sent' : 'ERROR',  verifyResult.status.code, verifyResult.data.userMessage] ]);
                        }
                    }
                >Decline Signature</Button>
                <Button
                    variant={'contained'}
                    color={'success'}
                    size={'large'}
                    sx={{width:'100%', padding:3, marginBottom:2,}}

                    onClick={
                        async () => {
                            let  verifyResult =  await signatureRequest(
                                {
                                    location : newGiftVoucherTerminalData.current.location,
                                    accepted: true
                                });
                            setNewGiftVoucherTerminalLog([...newGiftVoucherTerminalLog, ...[verifyResult.status.ok ? 'Signature request sent' : 'ERROR',  verifyResult.status.code, verifyResult.data.userMessage] ]);
                        }
                    }
                >Accept Signature</Button>
            </>
        ))
    }

    const generateGiftCard = async (paymentType, paymentData) => {
        setNewGiftVoucherTransactionResult(null);
        var formdata = new FormData();
        formdata.append("payment_data", JSON.stringify(paymentData));
        formdata.append("payment_type", paymentType);
        formdata.append("amount", newGiftVoucherAmount);
        formdata.append("epos_user_key", userKey);

        var reqHeaders = new Headers();
        reqHeaders.append("Accept", "application/json");
        reqHeaders.append("Authorization", accessToken);
        var requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: formdata,
            redirect: 'follow'
        };

        let requestData = await fetch(apiRoutes.generateGiftVoucher, requestOptions)
            .then(response => {
                if (!response.ok) {
                    setNewGiftVoucherError('Error Creating Gift Card');
                    setNewGiftVoucherProcessing(false);
                    return false;
                }

                return response.json()
            }).then(json => {
                return json;
            });

        if(requestData.error) {
            setNewGiftVoucherError(requestData.errorMessage);
        } else  {
            setNewGiftVoucher(requestData.gift_voucher);
            if(!printerInitialised) {
                await initialisePrinter();
            }

            const footer = await printFooter();
            const header = await printHeader();
            let paymentRows = null;
            const  paymentName = paymentType.charAt(0).toUpperCase() + paymentType.slice(1).replaceAll('_', ' ');
            if(paymentType === 'cash') {
                paymentRows = (
                    <Row left={paymentName} right={'£' + requestData.gift_voucher.amount.toFixed(2)} />
                );
            }

            if(paymentType === 'card') {
                paymentRows = (
                    <>
                        <Row left={paymentName} right={'£' + requestData.gift_voucher.amount.toFixed(2)} />
                        <Line />
                        <Row left={'TID'} right={paymentData.data.transactionId ?? '-'} />
                        <Row left={'Type'} right={paymentData.data.cardSchemeName ?? '-'} />
                        <Row left={'Number'} right={paymentData.data.primaryAccountNumber ?? '-'} />
                        <Row left={'AID'} right={paymentData.data.applicationId ?? '-'} />
                        <Row left={'PAN Seq. no'} right={paymentData.data.primaryAccountNumberSequence ?? '-'} />
                        <Row left={'Auth. Code'} right={paymentData.data.authCode ?? '-'} />
                    </>
                );
            }


            const receipt = await (
                <Printer type={printerType} width={printerWidth} >
                    <Br/>
                    <Text align={'center'} >Gift Voucher Code</Text>
                    <Text align={'center'} >{requestData.gift_voucher.code}</Text>
                    <Text align={'center'} >{'£' + requestData.gift_voucher.amount.toFixed(2)}</Text>
                    <Line />
                    {paymentRows}
                    <Line />
                    {footer}
                    {header}
                </Printer>
            );

            await sendToPrinter(receipt, false);

            setNewGiftVoucherComplete(true);
            setNewGiftVoucherProcessing(false);

        }
    }



    /** Refund Functionality */
    const refundTerminalDataDefaultState = {
        started : false,
        location: null,
        transactionID : null,
        transactionNumber : null,
        transactionStatus : null,
        transactionLog : [],
        transactionStatusLog : [],
    }
    const [showRefundCreatorModal, setShowRefundCreatorModal] = useState(false);
    const [refundProcessing, setRefundProcessing] = useState(false);
    const [refundError, setRefundError] = useState(false);
    const [refundComplete, setRefundComplete] = useState(false);

    const [refundAmount, setRefundAmount] = useState(0);
    const [refund, setRefund] = useState(false);
    const [refundPaymentMethod, setRefundPaymentMethod] = useState('card');
    const [refundNote, setRefundNote] = useState('');

    const refundTerminalData = useRef(refundTerminalDataDefaultState);
    const refundTerminalTimer = useRef(false);
    const [refundTerminalLog, setRefundTerminalLog] = useState([]);
    const [refundTransactionResult, setRefundTransactionResult] = useState([]);

    const createRefund = () => {
        setShowRefundCreatorModal(true);

    }
    const resetRefundCreator = () => {
        setShowRefundCreatorModal(false);
        setRefundAmount(0);
        setRefundPaymentMethod('card');
        setRefundNote('');
        setRefundProcessing(false);
        setRefundError(false);
        setRefundComplete(false);

        setRefundTerminalLog([]);
        setRefundTransactionResult(null);
        refundTerminalData.current = refundTerminalDataDefaultState
    }

    const prepareRefundTransaction = () => {

        setRefundError(false);
        setRefundComplete(false);
        setRefund(false);
        setRefundTerminalLog([]);
        setRefundTransactionResult(null);
        refundTerminalData.current = refundTerminalDataDefaultState;

    }

    const processRefundRequest = async () => {
        setRefundProcessing(true);

        await prepareRefundTransaction();


        if(refundPaymentMethod == 'cash') {
            await generateRefund('cash', null)
        } else  {
            startRefundCardTransaction()
        }

    }

    const startRefundCardTransaction = () => {
        if(!refundTerminalData.current.started) {
            refundTerminalData.current.started = true;
            let transactionStartupLog = [];
            transactionStartupLog.push(new Date().toISOString());
            transactionStartupLog.push('Starting card transaction');
            if(!terminalID) {
                transactionStartupLog.push('No Terminal Selected');
                setRefundError('No Terminal Selected');
                refundTerminalData.current.transactionLog = transactionStartupLog;
                setRefundTerminalLog(refundTerminalDataDefaultState.current.transactionLog);
                setRefundProcessing(false);
                return;
            }
            transactionStartupLog.push('Terminal ID : ' + terminalID);
            refundTerminalData.current.transactionLog = transactionStartupLog;
            setRefundTerminalLog(refundTerminalData.current.transactionLog);
            sendRefundPaymentToTerminal()
        }
    }
    const sendRefundPaymentToTerminal = async () => {
        let transactionLog = [];

        let response = await sendRefund({
            amount : (Math.abs(refundAmount)),
            terminalID: terminalID
        });

        if(response.status.ok) {
            beginRefundTransactionChecks(response.data.location);
        } else  {
            let message = '';
            message += response.data.userMessage ?? '';
            message += response.status.text ?? '';
            message += ' : ';
            message += response.status.code;
            transactionLog.push(message);
        }
        refundTerminalData.current.transactionLog = [...refundTerminalData.current.transactionLog, ...transactionLog]
        setRefundTerminalLog(refundTerminalData.current.transactionLog);
        console.log(response)

    }

    const beginRefundTransactionChecks = async (location) => {
        refundTerminalData.current.location = location;
        checkRefundTransaction();
    }

    const checkRefundTransaction = async () => {
        clearTimeout(refundTerminalTimer.current);
        let transactionLog = [];
        const transactionStatus = await getStatus({
            location: refundTerminalData.current.location,
        });

        let transactionFinished = false;
        console.log(refundTerminalData.current.location);
        console.log(transactionStatus);

        if (transactionStatus.status.ok) {
            transactionLog = transactionStatus.data.notifications;
            refundTerminalData.current.transactionStatus = transactionStatus;
            refundTerminalData.current.transactionID = (transactionStatus.data.transactionId ?? null);
            refundTerminalData.current.transactionNumber = (transactionStatus.data.transactionNumber ?? null);


            if (transactionStatus.data.notifications[0] == 'TRANSACTION_FINISHED') {
                transactionFinished = true;
                transactionLog.push(transactionStatus.data.userMessage);
                if (transactionStatus.data.transactionResult === 'SUCCESSFUL') {
                    refundTransactionSuccessful();
                } else if(transactionStatus.data.transactionResult === 'TIMED_OUT') {
                    refundTransactionTimedOut();
                } else {
                    refundTransactionFailed();
                }
            } else if(transactionStatus.data.notifications[0] == 'SIGNATURE_VERIFICATION') {
                refundTransactionRequiresSignature();
            } else  {
                console.log(transactionStatus.data.notifications[0])
            }
        }


        if (!transactionFinished) {
            refundTerminalTimer.current = setTimeout(() => {
                console.log('firing Refund recheck');
                checkRefundTransaction()
            }, 1000)
        }

        refundTerminalData.current.transactionStatusLog = transactionLog.reverse()
        setRefundTerminalLog([...refundTerminalData.current.transactionLog, ...refundTerminalData.current.transactionStatusLog])
    }

    const refundTransactionSuccessful = async () => {
        await generateRefund('card', refundTerminalData.current.transactionStatus);
    }

    const refundTransactionFailed = () => {
        setRefundTransactionResult(null);
        setRefundComplete(false);
        setRefundProcessing(false);
        setRefundError('Transaction Failed : ' + refundTerminalData.current.transactionStatus.data.transactionResult );
    }

    const refundTransactionTimedOut = () => {
        setRefundTransactionResult(() => (
            <>
                <Button
                    fullWidth={true}
                    variant={'contained'}
                    color={'success'}
                    size={'large'}
                    sx={{width:'100%', padding:3, marginBottom:2}}

                    onClick={() => {
                        refundTransactionSuccessful();
                    }}>
                    Transaction Successful
                </Button>
                <Button
                    fullWidth={true}
                    variant={'contained'}
                    color={'error'}
                    size={'large'}
                    sx={{width:'100%', padding:3, marginBottom:2}}

                    onClick={() => {
                        refundTransactionFailed();
                    }}>
                    Transaction Failed
                </Button>
            </>
        ))
    }

    const refundTransactionRequiresSignature = () => {
        setRefundTransactionResult(() => (
            <>
                <Button
                    variant={'contained'}
                    color={'error'}
                    size={'large'}
                    sx={{width:'100%', padding:3, marginBottom:2,}}

                    onClick={
                        async () => {
                            let  verifyResult =  await signatureRequest({
                                location : refundTerminalData.current.location,
                                terminalID : terminalID,
                                accepted: false});
                            setRefundTerminalLog([...refundTerminalLog, ...[verifyResult.status.ok ? 'Signature request sent' : 'ERROR',  verifyResult.status.code, verifyResult.data.userMessage] ]);
                        }
                    }
                >Decline Signature</Button>
                <Button
                    variant={'contained'}
                    color={'success'}
                    size={'large'}
                    sx={{width:'100%', padding:3, marginBottom:2,}}

                    onClick={
                        async () => {
                            let  verifyResult =  await signatureRequest(
                                {
                                    location : refundTerminalData.current.location,
                                    accepted: true
                                });
                            setRefundTerminalLog([...refundTerminalLog, ...[verifyResult.status.ok ? 'Signature request sent' : 'ERROR',  verifyResult.status.code, verifyResult.data.userMessage] ]);
                        }
                    }
                >Accept Signature</Button>
            </>
        ))
    }

    const generateRefund = async (paymentType, paymentData) => {
        setRefundTransactionResult(null);
        var formdata = new FormData();
        formdata.append("payment_data", JSON.stringify(paymentData));
        formdata.append("payment_type", paymentType);
        formdata.append("amount", (-1 * Math.abs(refundAmount)));
        formdata.append("note", refundNote);
        formdata.append("epos_user_key", userKey);

        var reqHeaders = new Headers();
        reqHeaders.append("Accept", "application/json");
        reqHeaders.append("Authorization", accessToken);
        var requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: formdata,
            redirect: 'follow'
        };

        let requestData = await fetch(apiRoutes.issueRefund, requestOptions)
            .then(response => {
                if (!response.ok) {
                    setRefundError('Error Creating Refund');
                    setRefundProcessing(false);
                    return false;
                }

                return response.json()
            }).then(json => {
                return json;
            });

        if(requestData.error) {
            setRefundError(requestData.errorMessage);
        } else  {
            setRefund(requestData.refund);
            if(!printerInitialised) {
                await initialisePrinter();
            }

            const footer = await printFooter();
            const header = await printHeader();
            let paymentRows = null;
            const  paymentName = paymentType.charAt(0).toUpperCase() + paymentType.slice(1).replaceAll('_', ' ');
            if(paymentType === 'cash') {
                paymentRows = (
                    <Row left={paymentName} right={'£' + requestData.refund.amount.toFixed(2)} />
                );
            }

            if(paymentType === 'card') {
                paymentRows = (
                    <>
                        <Row left={paymentName} right={'£' + requestData.refund.amount.toFixed(2)} />
                        <Line />
                        <Row left={'TID'} right={paymentData.data.transactionId ?? '-'} />
                        <Row left={'Type'} right={paymentData.data.cardSchemeName ?? '-'} />
                        <Row left={'Number'} right={paymentData.data.primaryAccountNumber ?? '-'} />
                        <Row left={'AID'} right={paymentData.data.applicationId ?? '-'} />
                        <Row left={'PAN Seq. no'} right={paymentData.data.primaryAccountNumberSequence ?? '-'} />
                        <Row left={'Auth. Code'} right={paymentData.data.authCode ?? '-'} />
                    </>
                );
            }


            const receipt = await (
                <Printer type={printerType} width={printerWidth} >
                    <Br/>
                    <Text align={'center'} >REFUND</Text>
                    <Text align={'center'} >{refundNote}</Text>
                    <Line />
                    {paymentRows}
                    <Line />
                    {footer}
                    {header}
                </Printer>
            );

            await sendToPrinter(receipt, false);

            setRefundComplete(true);
            setRefundProcessing(false);

        }
    }



    /** Coach Driver Functionality */

    const getCoachDrivers = async () => {
        if(coachDriverOpen || selectDriverForPayoutModalOpen) {
            setCoachDrivers(false);
            var reqHeaders = new Headers();
            reqHeaders.append("Accept", "application/json");
            reqHeaders.append("Authorization", accessToken);

            var requestOptions = {
                method: 'GET',
                headers: reqHeaders,
                redirect: 'follow'
            };

            let coachDrivers = await fetch(apiRoutes.getCoachDriverList, requestOptions)
                .then(response => {
                    if (!response.ok) {
                        setErrorMessage('Error Fetching Coach Drivers - Bad Response')
                        return false;
                    }

                    return response.json()
                }).then(json => {
                    return json;
                });

            setCoachDrivers(coachDrivers);

        }
    }

    const getPayoutData = async () => {
        setPayoutData('loading');

        var reqHeaders = new Headers();
        reqHeaders.append("Accept", "application/json");
        reqHeaders.append("Authorization", accessToken);
        var requestOptions = {
            method: 'GET',
            headers: reqHeaders,
            redirect: 'follow'
        };

        let requestData = await fetch(apiRoutes.getCoachDriverPayoutData + '/' + payoutDriver.id, requestOptions)
            .then(response => {
                if (!response.ok) {
                    setErrorMessage('Error Fetching Coach Drivers - Bad Response')
                    setPayoutData(false);
                    return false;
                }

                return response.json()
            }).then(json => {
                return json;
            });

        setPayoutData(requestData);
    }

    const processCommissionPayout = async () => {
        setShowPayoutProcessing(true);
        setDriverPayoutModal(false);

        let bookingIds = [];
        //extract booking ids from payoutData.coachDriver.unpaid_bookings
        payoutData.coachDriver.unpaid_bookings.forEach((booking) => {
            bookingIds.push(booking.id);
        });


        var formdata = new FormData();
        formdata.append("estimated_amount", payoutData.estimatedPayout);
        formdata.append("booking_ids", JSON.stringify(bookingIds));
        formdata.append("epos_user_key", userKey);

        var reqHeaders = new Headers();
        reqHeaders.append("Accept", "application/json");
        reqHeaders.append("Authorization", accessToken);
        var requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: formdata,
            redirect: 'follow'
        };

        let requestData = await fetch(apiRoutes.submitCoachDriverPayoutRequest + '/' + payoutDriver.id, requestOptions)
            .then(response => {
                if (!response.ok) {
                    setErrorMessage('Error Creating Commission Payment - Bad Response')
                    setPayoutDriver(false);
                    setPayoutData(false);
                    setDriverPayoutModal(false);
                    setShowPayoutProcessing(false);
                    return false;
                }

                return response.json()
            }).then(json => {
                return json;
            });

        if(requestData.error) {
            setErrorMessage(requestData.errorMessage);
        } else  {

            if(!printerInitialised) {
                await initialisePrinter();
            }

            const footer = await printFooter();
            const header = await printHeader();

            const receipt = await (
                <Printer type={printerType} width={printerWidth} >
                    <Br/>
                    <Row left={'Commission ID'} right={requestData.payout.id}/>
                    <Row left={'Driver'} right={requestData.driver.name}/>
                    <Row left={'Driver Commission'} right={'£' + requestData.amount.toFixed(2)}/>
                    <Line />
                    {footer}
                    {header}
                </Printer>
            );

            await sendToPrinter(receipt, false);
            setPayoutAmount(requestData.amount.toFixed(2));
        }
    }


    const getDiscounts = async () => {
        if(discountsOpen) {
            setCoachDrivers(false);
            var reqHeaders = new Headers();
            reqHeaders.append("Accept", "application/json");
            reqHeaders.append("Authorization", accessToken);

            var requestOptions = {
                method: 'GET',
                headers: reqHeaders,
                redirect: 'follow'
            };

            let discountList = await fetch(apiRoutes.getDiscountsList, requestOptions)
                .then(response => {
                    if (!response.ok) {
                        setErrorMessage('Error Fetching Discounts - Bad Response')
                        return false;
                    }

                    return response.json()
                }).then(json => {
                    return json;
                });

            setAvailableDiscounts(discountList);

        }
    }

    const updatePaymentStatus = async () => {
        let newAmountPaid = 0;

        // change can only be given on cash;
        let availableChange = 0;
        paymentsMade.current.forEach((payment) => {
            newAmountPaid += payment.amount;
            if(payment.type == 'cash') {
                availableChange += payment.amount;
            }
        });

        setAmountPaid(newAmountPaid);
        if(newAmountPaid >= total) {
            setProcessingBooking(true);
            changeDue.current = (newAmountPaid - total);

            if(changeDue.current > availableChange) {
                changeDue.current = availableChange
            }

            updateBookingInProgress.current = true;
            const bookingSaved =  await submitBooking();
            if(bookingSaved) {
                await printReceipt();
                setPostBookingModalOpen(true)
            }
            updateBookingInProgress.current = false;
            setProcessingBooking(false);
        }

    }
    const submitBooking = async () => {

        var reqHeaders = new Headers();
        reqHeaders.append("Accept", "application/json");
        reqHeaders.append("Authorization", accessToken);

        if(!Object.keys(bookingManifest.current).length || passengers.current <= 0) {
            console.log('empty manifest #SB001')
            return false;
        }

        var formdata = new FormData();
        if(bookingId.current) {
            formdata.append("id", bookingId.current);
        }
        formdata.append("trip_id", tripID);
        formdata.append("journey_type", journeyType.id);
        formdata.append("num_adults", bookingManifest.current.passengers.adults);
        formdata.append("num_children", bookingManifest.current.passengers.children);
        formdata.append("num_toddlers", bookingManifest.current.passengers.toddlers);
        formdata.append("num_families", bookingManifest.current.passengers.families);
        formdata.append("num_vips", bookingManifest.current.passengers.vips);
        formdata.append("num_spectators", bookingManifest.current.passengers.spectators);
        formdata.append("num_passengers", passengers.current);
        formdata.append("base_price", bookingManifest.current.subtotal);
        formdata.append("total_price", bookingManifest.current.total);
        formdata.append("price_breakdown", JSON.stringify(priceBreakdown.current));
        formdata.append("discount_id", bookingManifest.current.selectedDiscount);
        formdata.append("discount_applied", bookingManifest.current.discount);
        formdata.append("private_notes", 'Ticket Hut Booking - ' + userKey );
        formdata.append("epos_user_key", userKey);
        formdata.append("payments", JSON.stringify(paymentsMade.current));
        formdata.append("change_due", changeDue.current);
        formdata.append("complete", true);

        var requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: formdata,
            redirect: 'follow'
        };

        return await fetch(apiRoutes.createBooking, requestOptions)
            .then(async response => {
                if (!response.ok) {
                    var json = await response.json();

                    if(json.error_message !== undefined) {
                        setErrorMessage(json.error_message);
                    } else  {
                        setErrorMessage('Error updating Booking - Bad Response')
                    }

                    return false;
                }

                return response.json()
            }).then(json => {
                return true;
            });



    }

    const postBookingReset = async () => {
        setBookingRef(null);
        bookingId.current = null;

        changeDue.current = 0;
        paymentsMade.current = [];
        resetPassengers();
        resetTrip();
        setAmountPaid(0);
        setPostBookingModalOpen(false);

    }

    const PaymentsMadeEl = () => {
        if(paymentsMade.current.length === 0) {
            return null;
        }
        return (
            <Grid xs={true}  >
                <Box  p={1} backgroundColor={'#ff8343'} >
                    {
                        paymentsMade.current.map((p, index) => {
                            let paymentName = p.type.charAt(0).toUpperCase() + p.type.slice(1).replaceAll('_', ' ');
                            if(p.code !== undefined) {
                                paymentName += ' - ' + p.code ;
                            }
                            return (
                                <Stack key={index} direction={"row"} alignContent="space-between" spacing={1} mb={1}
                                       sx={{alignContent: 'center', justifyContent: 'space-between'}}>
                                    {p.removable ? <AlertDialog
                                            buttonContent={<FontAwesomeIcon icon='fa-times-square'/>}
                                            dialogTitle={'Remove Payment - ' + p.type + ' - £' + (p.amount.toFixed(2))}
                                            dialogAction={() => {
                                                removePayment(index);
                                            }}
                                            iconButton={true}
                                            buttonStyle={{p: 0}}
                                        />
                                        : null}
                                    <Typography sx={{fontWeight: 'bold'}}
                                                flexGrow={1}>{paymentName} {p.changeDue}</Typography>
                                    <Typography sx={{fontWeight: 'bold'}}>£{p.amount.toFixed(2)}</Typography>
                                </Stack>
                            )
                        })
                    }
                </Box>
            </Grid>
        )
    }

    /**
     * Card Payment Functionality
     */
    const [cardPaymentInProgress, setCardPaymentInProgress] = useState(false);
    const cardTransactionData = useRef({});
    const [cardPaymentLog, setCardPaymentLog] = useState([]);
    const [transactionData, setTransactionData] = useState('-');
    const [transactionID, setTransactionID] = useState(null);
    const transactionStarted = useRef(false);
    const terminalTimer = useRef(null);
    const transactionLocation = useRef(null);
    const [transactionResult, setTransactionResult] = useState(null);
    const [logBg, setLogBg] = useState('black');

    const startTransactionCycle = () => {
        if(!transactionStarted.current) {
            transactionStarted.current = true;
            let newCardPaymentLog = [];
            newCardPaymentLog.push(new Date().toISOString());
            newCardPaymentLog.push('Starting card transaction');

            if(!terminalID) {
                newCardPaymentLog.push('No Terminal Selected');
                setCardPaymentLog(newCardPaymentLog);
                setCardPaymentInProgress(false);
                return;
            }
            if((total - amountPaid) <= 0) {
                newCardPaymentLog.push('Nothing to pay');
                setCardPaymentLog(newCardPaymentLog);
                setCardPaymentInProgress(false);
                return;
            }

            newCardPaymentLog.push('Terminal ID : ' + terminalID);
            setCardPaymentInProgress(true);
            setCardPaymentLog(newCardPaymentLog);
            sendPaymentToTerminal();
        }
    }

    const sendPaymentToTerminal = async () => {
        let newCardPaymentLog = [];

        let response = await sendSale({
            amount: (total - amountPaid),
            terminalID : terminalID
        });
        setTransactionData(response);
        if(response.status.ok) {
            beginTransactionChecks(response.data.location);
        } else  {
            let message = '';
            message += response.data.userMessage ?? '';
            message += response.status.text ?? '';
            message += ' : ';
            message += response.status.code;

            newCardPaymentLog.push(message);
            setCardPaymentInProgress(false);
        }
        setCardPaymentLog([ ...cardPaymentLog, ...newCardPaymentLog]);
        console.log(response);
    }

    const transactionSuccessful = () => {
        let cardAmount = cardTransactionData.current.transactionStatus.data.amountTotal/100;

        if(cardAmount === 0) {
            /**
             * If the card payment timed out, the amount will be 0 therefore build from initial request
             */
            cardAmount = (total - amountPaid);
            cardTransactionData.current.transactionStatus.data.amountTotal = cardAmount * 100;
        }

        payCardComplete(cardTransactionData.current, cardAmount);
        setCardPaymentInProgress(false);

        setLogBg('#0f9900');
        setTransactionResult(() => (
            <Alert severity="success">
                Transaction Successful
            </Alert>
        ));
    }

    const transactionUnsuccessful = (result) => {
        setLogBg('#990000');
        setTransactionResult(() => (
            <Alert severity="error">
                Transaction Unsuccessful - {result}
            </Alert>
        ));
        setCardPaymentInProgress(false);
    }

    const transactionTimeOut = () => {
        setLogBg('#0f5885');
        setCardPaymentInProgress(false);
        setTransactionResult(() => (

            <Button
                variant={'contained'}
                color={'success'}
                size={'large'}
                sx={{width:'100%', padding:3, marginBottom:2}}

                onClick={() => {
                    transactionSuccessful();
                }}>
                Transaction Successful
            </Button>
        ))

    }
    const transactionRequiresSignature = () => {
        setLogBg('#ff5900');
        setTransactionResult(() => (
            <>
                <Button
                    variant={'contained'}
                    color={'error'}
                    size={'large'}
                    sx={{width:'100%', padding:3, marginBottom:2,}}

                    onClick={
                        async () => {
                            let  verifyResult =  await signatureRequest({
                                location : transactionLocation.current,
                                terminalID : terminalID,
                                accepted: false});
                            setCardPaymentLog([...cardPaymentLog, ...[verifyResult.status.ok ? 'Signature request sent' : 'ERROR',  verifyResult.status.code, verifyResult.data.userMessage] ]);
                        }
                    }
                >Decline Signature</Button>
                <Button
                    variant={'contained'}
                    color={'success'}
                    size={'large'}
                    sx={{width:'100%', padding:3, marginBottom:2,}}

                    onClick={
                        async () => {
                            let  verifyResult =  await signatureRequest({location : transactionLocation.current, accepted: true});
                            setCardPaymentLog([...cardPaymentLog, ...[verifyResult.status.ok ? 'Signature request sent' : 'ERROR',  verifyResult.status.code, verifyResult.data.userMessage] ]);
                        }
                    }
                >Accept Signature</Button>
            </>
        ))
    }

    const beginTransactionChecks = (location) => {
        transactionLocation.current = location;
        checkTransaction();
    }

    const checkTransaction = async () => {
        clearTimeout(terminalTimer.current);
        let newCardPaymentLog = [];

        const transactionStatus = await getStatus({
            location : transactionLocation.current
        });
        setTransactionData(transactionStatus);


        let transactionFinished = false;

        console.log(transactionLocation.current);
        console.log(transactionStatus);

        if(transactionStatus.status.ok) {
            let newTerminalMessage =  transactionStatus.data.notifications;
            let transactionIdentifiers = [];

            transactionIdentifiers.push('Transaction ID: ' +  (transactionStatus.data.transactionId ?? '-'));
            transactionIdentifiers.push('Transaction Number: '  + (transactionStatus.data.transactionNumber ?? '-'));

            cardTransactionData.current.transactionStatus = transactionStatus;

            setTransactionID(transactionIdentifiers.filter(n => n).join("\r\n"));

            if(transactionStatus.data.notifications[0] == 'TRANSACTION_FINISHED') {

                transactionFinished = true;

                newTerminalMessage.push(transactionStatus.data.userMessage);

                if(transactionStatus.data.transactionResult === 'SUCCESSFUL') {
                    transactionSuccessful();

                } else if(transactionStatus.data.transactionResult === 'TIMED_OUT') {
                    transactionTimeOut();
                } else {
                    transactionUnsuccessful(transactionStatus.data.transactionResult)
                }

            } else if(transactionStatus.data.notifications[0] == 'SIGNATURE_VERIFICATION') {
                transactionRequiresSignature();
            } else  {
                console.log(transactionStatus.data.notifications[0])
            }

            setCardPaymentLog([...cardPaymentLog, ...newTerminalMessage.slice().reverse()]);

        } else  {
            setTransactionID([]);
        }

        if(!transactionFinished) {
            terminalTimer.current = setTimeout(() => {
                console.log('firing recheck');
                checkTransaction()
            }, 1000)
        }
    }

    const RenderLog = ({log, bgColor}) => {
        bgColor = bgColor ?? 'black';

        let transactionLog = ( log ?? [] ).slice().reverse();

        return (
            <Box p={2} mb={2} sx={{
                background:bgColor,
                color: 'white',
                fontFamily: 'monospace',
                maxHeight:'25vh',
                overflowY: 'scroll',
                display:'flex',
                flexDirection: 'column-reverse',
            }}>
                {

                    transactionLog.map(
                        (logMsg, index) => (
                            <Typography key={index} sx={{ fontFamily: 'monospace'}}>{logMsg}</Typography>
                        )
                    )
                }
            </Box>
        )
    }


    /* PREBOOKINGS SECTION */

    const prebookingTerminalDataDefaultState = {
        started : false,
        location: null,
        transactionID : null,
        transactionNumber : null,
        transactionStatus : null,
        transactionLog : [],
        transactionStatusLog : [],
    }

    const [showPreBookedBookingsModal, setShowPreBookedBookingsModal] = useState(false);
    const [showPreBookedBookingActionModal, setShowPreBookedBookingActionModal] = useState(false);
    const [showPreBookedBookingPaymentModal, setShowPreBookedBookingPaymentModal] = useState(false);
    const [loadingPreBookedBookings, setLoadingPreBookedBookings] = useState(false);
    const [processingPreBookedBookings, setProcessingPreBookedBookings] = useState(false);
    const [prebookedBookings, setPreBookedBookings] = useState([]);
    const [prebookedBooking, setPreBookedBooking] = useState(false);
    const [prebookingPaymentMethod, setPrebookingPaymentMethod] = useState('card');
    const [prebookingPaymentInProgress, setPrebookingPaymentInProgress] = useState(false);

    const prebookingTerminalData = useRef(prebookingTerminalDataDefaultState);
    const prebookingTerminalTimer = useRef(false);
    const [prebookingTerminalLog, setPrebookingTerminalLog] = useState([]);
    const [prebookingError, setPrebookingError] = useState(false);
    const [prebookingComplete, setPrebookingComplete] = useState(false);
    const [prebookingTransactionResult, setPrebookingTransactionResult] = useState(null);

    const openPreBookingModal = () => {
        setShowPreBookedBookingsModal(true);
    }
    const closePreBookingModal = () => {
        setShowPreBookedBookingsModal(false);
    }
    const openPrebookingActionModal = (booking) => {
        closePreBookingModal();
        setPreBookedBooking(booking);
        setShowPreBookedBookingActionModal(true);
    }
    const closePrebookingActionModal = (booking) => {
        openPreBookingModal();
        setPreBookedBooking(false);
        setShowPreBookedBookingActionModal(false);
    }

    const openPrebookingPaymentModal = () => {
        setShowPreBookedBookingPaymentModal(true);
        setShowPreBookedBookingActionModal(false);
    }
    const closePrebookingPaymentModal = () => {
        setPrebookingPaymentMethod('card');
        setShowPreBookedBookingPaymentModal(false);
        setShowPreBookedBookingActionModal(true);
        preparePrebookingTransaction();
    }


    const getPreBookedBookings = async () => {
        setLoadingPreBookedBookings(true);
        var reqHeaders = new Headers();
        reqHeaders.append("Accept", "application/json");
        reqHeaders.append("Authorization", accessToken);

        var formdata = new FormData();

        formdata.append("epos_user_key", userKey);

        var requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: formdata,
            redirect: 'follow'
        };

        await fetch(apiRoutes.getPreBookedBookings, requestOptions)
            .then(response => {
                console.log(response);
                setLoadingPreBookedBookings(false);

                if (!response.ok) {
                    setErrorMessage('Error Fetching Pre-Booked Bookings - Bad Response')
                    return false;
                }
                return response.json();
            }).then(json => {
                setErrorMessage(null);
                setPreBookedBookings(json.bookings ?? []);
            });

        setLoadingPreBookedBookings(false);

    }

    useEffect(() => {
        if(showPreBookedBookingsModal) {
            getPreBookedBookings();
        }
    }, [
        showPreBookedBookingsModal
    ]);

    const getPreBookedBoardingPasses = async (bookingData) => {

        let adultBoardingCards = null;
        let childBoardingCards = null;
        let toddlerBoardingCards = null;
        let vipBoardingCards = null;
        let spectatorBoardingCards = null;
        let familyBoardingCards = null;
        let qrCodeDataUrl = null;

        const tripTitle = bookingData.trip.trip_type.name;
        const boatInfo = bookingData.trip.boat.name;
        const tripInfo = [
            bookingData.trip.niceDate,
            bookingData.trip.depart_time_nice,
            bookingData.trip.arrival_time_nice
        ].join(' - ');
        const journeyInfo = bookingData.journey_type_text;
        const tripItenary = [
            bookingData.trip.depart.name,
            bookingData.trip.arrival.name
        ].join(' - ');

        if (bookingData.num_adults > 0) {
            qrCodeDataUrl = await QRCode.toDataURL(
                'INDIVIDUAL_ADULT-' + bookingData.id,
                { errorCorrectionLevel: 'H', width:400 }
            );
            //render a board pass for each adult
            adultBoardingCards = (
                <>
                    {Array(bookingData.num_adults).fill(0).map((_, index) => {

                            return (
                                <>
                                    <Br/>
                                    <Cut lineFeeds={printerCutLineFeeds}/>
                                    <Br/>
                                    <Br/>
                                    <Text align={'center'}>Plymouth Boat Trips</Text>
                                    <Br/>
                                    <Line/>

                                    <Text align={"center"}>{tripTitle}</Text>
                                    <Text align={"center"}>{boatInfo}</Text>
                                    <Text align={"center"}>{tripInfo}</Text>
                                    <Text align={"center"}>{tripItenary}</Text>
                                    <Text align={"center"}>{journeyInfo}</Text>
                                    <Text align={"center"} bold={true} style={{width:2,height:2}}>{'ADULT TICKET'}</Text>
                                    <Br/>
                                    <Image align="center"  src={qrCodeDataUrl} />
                                    <Line/>
                                </>
                            );
                        }
                    )
                    }
                </>
            );
        }

        if (bookingData.num_children > 0) {
            qrCodeDataUrl = await QRCode.toDataURL(
                'INDIVIDUAL_CHILD-' + bookingData.id,
                { errorCorrectionLevel: 'H', width:400 }
            );
            //render a board pass for each adult
            childBoardingCards = (
                <>
                    {Array(bookingData.num_children).fill(0).map((_, index) => {

                            return (
                                <>
                                    <Br/>
                                    <Cut lineFeeds={printerCutLineFeeds}/>
                                    <Br/>
                                    <Br/>
                                    <Text align={'center'}>Plymouth Boat Trips</Text>
                                    <Br/>
                                    <Line/>

                                    <Text align={"center"}>{tripTitle}</Text>
                                    <Text align={"center"}>{boatInfo}</Text>
                                    <Text align={"center"}>{tripInfo}</Text>
                                    <Text align={"center"}>{tripItenary}</Text>
                                    <Text align={"center"}>{journeyInfo}</Text>
                                    <Text align={"center"} bold={true} style={{width:2,height:2}}>{'CHILD TICKET'}</Text>
                                    <Br/>
                                    <Image align="center"  src={qrCodeDataUrl} />
                                    <Line/>
                                </>
                            );
                        }
                    )
                    }
                </>
            );
        }

        if (bookingData.num_toddlers > 0) {
            qrCodeDataUrl = await QRCode.toDataURL(
                'INDIVIDUAL_TODDLER-' + bookingData.id,
                { errorCorrectionLevel: 'H', width:400 }
            );
            //render a board pass for each adult
            toddlerBoardingCards = (
                <>
                    {Array(bookingData.num_toddlers).fill(0).map((_, index) => {

                            return (
                                <>
                                    <Br/>
                                    <Cut lineFeeds={printerCutLineFeeds}/>
                                    <Br/>
                                    <Br/>
                                    <Text align={'center'}>Plymouth Boat Trips</Text>
                                    <Br/>
                                    <Line/>

                                    <Text align={"center"}>{tripTitle}</Text>
                                    <Text align={"center"}>{boatInfo}</Text>
                                    <Text align={"center"}>{tripInfo}</Text>
                                    <Text align={"center"}>{tripItenary}</Text>
                                    <Text align={"center"}>{journeyInfo}</Text>
                                    <Text align={"center"} bold={true} style={{width:2,height:2}}>{'TODDLER TICKET'}</Text>
                                    <Br/>
                                    <Image align="center"  src={qrCodeDataUrl} />
                                    <Line/>
                                </>
                            );
                        }
                    )
                    }
                </>
            );
        }

        if (bookingData.num_spectators > 0) {
            qrCodeDataUrl = await QRCode.toDataURL(
                'INDIVIDUAL_SPECTATOR-' + bookingData.id,
                { errorCorrectionLevel: 'H', width:400 }
            );
            //render a board pass for each adult
            spectatorBoardingCards = (
                <>
                    {Array(bookingData.num_spectators).fill(0).map((_, index) => {

                            return (
                                <>
                                    <Br/>
                                    <Cut lineFeeds={printerCutLineFeeds}/>
                                    <Br/>
                                    <Br/>
                                    <Text align={'center'}>Plymouth Boat Trips</Text>
                                    <Br/>
                                    <Line/>

                                    <Text align={"center"}>{tripTitle}</Text>
                                    <Text align={"center"}>{boatInfo}</Text>
                                    <Text align={"center"}>{tripInfo}</Text>
                                    <Text align={"center"}>{tripItenary}</Text>
                                    <Text align={"center"}>{journeyInfo}</Text>
                                    <Text align={"center"} bold={true} style={{width:2,height:2}}>{'SPECTATOR TICKET'}</Text>
                                    <Br/>
                                    <Image align="center"  src={qrCodeDataUrl} />
                                    <Line/>
                                </>
                            );
                        }
                    )
                    }
                </>
            );
        }

        if (bookingData.num_families > 0) {
            let qrCodeDataUrl = await QRCode.toDataURL(
                'INDIVIDUAL_FAMILY-' + bookingData.id,
                { errorCorrectionLevel: 'H', width:400 }
            );
            //render a board pass for each adult
            familyBoardingCards = (
                <>
                    {Array(bookingData.num_families).fill(0).map((_, index) => {

                            return (
                                <>
                                    <Br/>
                                    <Cut lineFeeds={printerCutLineFeeds}/>
                                    <Br/>
                                    <Br/>
                                    <Text align={'center'}>Plymouth Boat Trips</Text>
                                    <Br/>
                                    <Line/>

                                    <Text align={"center"}>{tripTitle}</Text>
                                    <Text align={"center"}>{boatInfo}</Text>
                                    <Text align={"center"}>{tripInfo}</Text>
                                    <Text align={"center"}>{tripItenary}</Text>
                                    <Text align={"center"}>{journeyInfo}</Text>
                                    <Text align={"center"} bold={true} style={{width:2,height:2}}>{'FAMILY TICKET'}</Text>
                                    <Br/>
                                    <Image align="center"  src={qrCodeDataUrl} />
                                    <Line/>
                                </>
                            );
                        }
                    )
                    }
                </>
            );
        }

        if (bookingData.num_vips > 0) {
            qrCodeDataUrl = await QRCode.toDataURL(
                'INDIVIDUAL_VIP-' + bookingData.id,
                { errorCorrectionLevel: 'H', width:400 }
            );
            //render a board pass for each adult
            vipBoardingCards = (
                <>
                    {Array(bookingData.num_vips).fill(0).map((_, index) => {

                            return (
                                <>
                                    <Br/>
                                    <Cut lineFeeds={printerCutLineFeeds}/>
                                    <Br/>
                                    <Br/>
                                    <Text align={'center'}>Plymouth Boat Trips</Text>
                                    <Br/>
                                    <Line/>
                                    <Text align={"center"}>{tripTitle}</Text>
                                    <Text align={"center"}>{boatInfo}</Text>
                                    <Text align={"center"}>{tripInfo}</Text>
                                    <Text align={"center"}>{tripItenary}</Text>
                                    <Text align={"center"}>{journeyInfo}</Text>
                                    <Text align={"center"} bold={true} style={{width:2,height:2}}>{'VIP TICKET'}</Text>
                                    <Br/>
                                    <Image align="center"  src={qrCodeDataUrl} />
                                    <Line/>
                                </>
                            );
                        }
                    )
                    }
                </>
            );
        }

        return (
            <>
                {adultBoardingCards}
                {childBoardingCards}
                {toddlerBoardingCards}
                {familyBoardingCards}
                {vipBoardingCards}
                {spectatorBoardingCards}
            </>
        )


    }

    const printPrebookedTickets = async(bookingData) => {

        if(!printerInitialised) {
            await initialisePrinter();
        }

        const footer = await printFooter();
        const header = await printHeader();
        const passengerBoardingPasses = await getPreBookedBoardingPasses(bookingData);


        const receipt = await (
            <Printer type={printerType} width={printerWidth} >
                <Br/>
                {bookingData.num_adults > 0 ? (<Text align={"left"}>{bookingData.num_adults + ' x Adult'}</Text>): null}
                {bookingData.num_children > 0 ? (<Text align={"left"}>{bookingData.num_children + ' x Child'}</Text>) : null}
                {bookingData.num_toddlers > 0 ? (<Text align={"left"}>{bookingData.num_toddlers + ' x Toddler'}</Text>) : null}
                {bookingData.num_spectators > 0 ? (<Text align={"left"}>{bookingData.num_spectators + ' x Spectator'}</Text>) : null}
                {bookingData.num_vips > 0 ? (<Text align={"left"}>{bookingData.num_vips + ' x VIP'}</Text>) : null}
                {bookingData.num_families > 0 ? (<Text align={"left"}>{bookingData.num_families + ' x Family'}</Text>) : null}

                <Row left={'Total'} right={'£' + bookingData.total_price.toFixed(2)}/>
                <Row left={'Outstanding'} right={'£' + bookingData.outstanding.toFixed(2)}/>

                <Line />
                <Text align={"center"}>{bookingData.trip.trip_title}</Text>
                <Text align={"center"}>{bookingData.trip.boat_name}</Text>
                <Text align={"center"}>{bookingData.trip.niceDate} - {bookingData.trip.depart_time_nice} - {bookingData.trip.arrival_time_nice}</Text>
                <Text align={"center"}>{bookingData.trip.depart_location} - {bookingData.trip.arrival_location}</Text>
                <Text align={"center"}>{bookingData.journey_type_text}</Text>
                <Line />
                {footer}
                {passengerBoardingPasses}
                {header}
            </Printer>
        );


        await sendToPrinter(receipt, false);

    }


    const preparePrebookingTransaction = () => {
        setPrebookingError(false);
        setPrebookingComplete(false);
        setPrebookingTerminalLog([]);
        setPrebookingTransactionResult(null);
        prebookingTerminalData.current = prebookingTerminalDataDefaultState;
    }

    const processPrebookingPayment = async() => {
        setPrebookingPaymentInProgress(true);
        await preparePrebookingTransaction();

        if(prebookingPaymentMethod === 'cash') {
            await submitPrebookingTransaction('cash');
        } else  {
            startPrebookingCardTransaction();
        }
    }

    const submitPrebookingTransaction = async (paymentType, paymentData) => {
        setPrebookingTransactionResult(null);

        var formdata = new FormData();
        formdata.append("payment_data", JSON.stringify(paymentData));
        formdata.append("payment_type", paymentType);
        formdata.append("amount", prebookedBooking.outstanding);
        formdata.append("epos_user_key", userKey);

        var reqHeaders = new Headers();
        reqHeaders.append("Accept", "application/json");
        reqHeaders.append("Authorization", accessToken);
        var requestOptions = {
            method: 'POST',
            headers: reqHeaders,
            body: formdata,
            redirect: 'follow'
        };

        let requestData = await fetch(apiRoutes.getSubmitPreBookedBooking + '/' + prebookedBooking.id, requestOptions)
            .then(response => {
                if (!response.ok) {
                    setPrebookingError('Error Submitting Prebooking Payment - Response Error');
                    setPrebookingPaymentInProgress(false);
                    return false;
                }

                return response.json()
            }).then(json => {
                return json;
            });

        if(requestData.error) {
            setPrebookingError(requestData.errorMessage);
        } else  {
            if(!printerInitialised) {
                await initialisePrinter();
            }

            const footer = await printFooter();
            const header = await printHeader();
            let paymentRows = null;
            const  paymentName = paymentType.charAt(0).toUpperCase() + paymentType.slice(1).replaceAll('_', ' ');
            if(paymentType === 'cash') {
                paymentRows = (
                    <Row left={paymentName} right={'£' + prebookedBooking.outstanding.toFixed(2)} />
                );
            }

            if(paymentType === 'card') {
                paymentRows = (
                    <>
                        <Row left={paymentName} right={'£' + prebookedBooking.outstanding.toFixed(2)} />
                        <Line />
                        <Row left={'TID'} right={paymentData.data.transactionId ?? '-'} />
                        <Row left={'Type'} right={paymentData.data.cardSchemeName ?? '-'} />
                        <Row left={'Number'} right={paymentData.data.primaryAccountNumber ?? '-'} />
                        <Row left={'AID'} right={paymentData.data.applicationId ?? '-'} />
                        <Row left={'PAN Seq. no'} right={paymentData.data.primaryAccountNumberSequence ?? '-'} />
                        <Row left={'Auth. Code'} right={paymentData.data.authCode ?? '-'} />
                    </>
                );
            }


            const receipt = await (
                <Printer type={printerType} width={printerWidth} >
                    <Br/>
                    <Text align={'center'} >Booking Payment</Text>
                    <Text align={'center'} >{prebookedBooking.booking_ref}</Text>
                    <Line />
                    {paymentRows}
                    <Line />
                    {footer}
                    {header}
                </Printer>
            );

            await sendToPrinter(receipt, false);

            setPrebookingComplete(true);
            setPrebookingPaymentInProgress(false);
            if(requestData.booking) {
                setPreBookedBooking(requestData.booking);
            }
        }
    }

    const startPrebookingCardTransaction = () => {
        if(!prebookingTerminalData.current.started) {
            prebookingTerminalData.current.started = true;
            let transactionStartupLog = [];
            transactionStartupLog.push(new Date().toISOString());
            transactionStartupLog.push('Starting card transaction');
            if(!terminalID) {
                transactionStartupLog.push('No Terminal Selected');
                setPrebookingError('No Terminal Selected');
                prebookingTerminalData.current.transactionLog = transactionStartupLog;
                setPrebookingTerminalLog(prebookingTerminalDataDefaultState.current.transactionLog);
                setPrebookingPaymentInProgress(false);
                return;
            }
            transactionStartupLog.push('Terminal ID : ' + terminalID);
            newGiftVoucherTerminalData.current.transactionLog = transactionStartupLog;
            setPrebookingTerminalLog(prebookingTerminalData.current.transactionLog);
            sendPrebookingPaymentToTerminal();
        }

    }

    const sendPrebookingPaymentToTerminal = async() => {
        let transactionLog = [];

        let response = await sendSale({
            amount : prebookedBooking.outstanding,
            terminalID: terminalID
        });

        if(response.status.ok) {
            beginPrebookingTransactionChecks(response.data.location);
        } else  {
            let message = '';
            message += response.data.userMessage ?? '';
            message += response.status.text ?? '';
            message += ' : ';
            message += response.status.code;
            transactionLog.push(message);
        }
        prebookingTerminalData.current.transactionLog = [...prebookingTerminalData.current.transactionLog, ...transactionLog]
        setPrebookingTerminalLog(prebookingTerminalData.current.transactionLog);
        console.log(response)
    }

    const beginPrebookingTransactionChecks = async (location) => {
        prebookingTerminalData.current.location = location;
        checkPrebookingTransaction();
    }

    const checkPrebookingTransaction = async () => {
        clearTimeout(prebookingTerminalTimer.current);
        let transactionLog = [];
        const transactionStatus = await getStatus({
            location: prebookingTerminalData.current.location,
        });

        let transactionFinished = false;
        console.log(prebookingTerminalData.current.location);
        console.log(transactionStatus);

        if (transactionStatus.status.ok) {
            transactionLog = transactionStatus.data.notifications;
            prebookingTerminalData.current.transactionStatus = transactionStatus;
            prebookingTerminalData.current.transactionID = (transactionStatus.data.transactionId ?? null);
            prebookingTerminalData.current.transactionNumber = (transactionStatus.data.transactionNumber ?? null);


            if (transactionStatus.data.notifications[0] == 'TRANSACTION_FINISHED') {
                transactionFinished = true;
                transactionLog.push(transactionStatus.data.userMessage);
                if (transactionStatus.data.transactionResult === 'SUCCESSFUL') {
                    prebookingTransactionSuccessful();
                } else if(transactionStatus.data.transactionResult === 'TIMED_OUT') {
                    prebookingTransactionTimedOut();
                } else {
                    prebookingTransactionFailed();
                }
            } else if(transactionStatus.data.notifications[0] == 'SIGNATURE_VERIFICATION') {
                prebookingTransactionRequiresSignature();
            } else  {
                console.log(transactionStatus.data.notifications[0])
            }
        }


        if (!transactionFinished) {
            prebookingTerminalTimer.current = setTimeout(() => {
                console.log('firing PB recheck');
                checkPrebookingTransaction()
            }, 1000)
        }
        prebookingTerminalData.current.transactionLog = prebookingTerminalData.current.transactionLog
        prebookingTerminalData.current.transactionStatusLog = transactionLog.reverse()
        setPrebookingTerminalLog([...prebookingTerminalData.current.transactionLog, ...prebookingTerminalData.current.transactionStatusLog])
    }

    const prebookingTransactionSuccessful = async () => {
        await submitPrebookingTransaction('card', prebookingTerminalData.current.transactionStatus);
    }

    const prebookingTransactionFailed = () => {
        setPrebookingTransactionResult(null);
        setPrebookingComplete(false);
        setPrebookingPaymentInProgress(false);
        setPrebookingError('Transaction Failed : ' + prebookingTerminalData.current.transactionStatus.data.transactionResult );
    }

    const prebookingTransactionTimedOut = () => {
        setPrebookingTransactionResult(() => (
            <>
                <Button
                    fullWidth={true}
                    variant={'contained'}
                    color={'success'}
                    size={'large'}
                    sx={{width:'100%', padding:3, marginBottom:2}}

                    onClick={() => {
                        prebookingTransactionSuccessful();
                    }}>
                    Transaction Successful
                </Button>
                <Button
                    fullWidth={true}
                    variant={'contained'}
                    color={'error'}
                    size={'large'}
                    sx={{width:'100%', padding:3, marginBottom:2}}

                    onClick={() => {
                        prebookingTransactionFailed();
                    }}>
                    Transaction Failed
                </Button>
            </>
        ))
    }

    const prebookingTransactionRequiresSignature = () => {
        setPrebookingTransactionResult(() => (
            <>
                <Button
                    variant={'contained'}
                    color={'error'}
                    size={'large'}
                    sx={{width:'100%', padding:3, marginBottom:2,}}

                    onClick={
                        async () => {
                            let  verifyResult =  await signatureRequest({
                                location : prebookingTerminalData.current.location,
                                terminalID : terminalID,
                                accepted: false});
                            setPrebookingTerminalLog([...prebookingTerminalLog, ...[verifyResult.status.ok ? 'Signature request sent' : 'ERROR',  verifyResult.status.code, verifyResult.data.userMessage] ]);
                        }
                    }
                >Decline Signature</Button>
                <Button
                    variant={'contained'}
                    color={'success'}
                    size={'large'}
                    sx={{width:'100%', padding:3, marginBottom:2,}}

                    onClick={
                        async () => {
                            let  verifyResult =  await signatureRequest(
                                {
                                    location : prebookingTerminalData.current.location,
                                    accepted: true
                                });
                            setPrebookingTerminalLog([...newGiftVoucherTerminalLog, ...[verifyResult.status.ok ? 'Signature request sent' : 'ERROR',  verifyResult.status.code, verifyResult.data.userMessage] ]);
                        }
                    }
                >Accept Signature</Button>
            </>
        ))
    }

    /**
     * Main Render
     */
    if(!tillUser) {
        return (
            <Grid container component="main" sx={{ height: '100vh' }} onClick={() => {
                startScreenProtector();
            }}>
                <Backdrop
                    sx={{backgroundColor:'rgba(20,68,97,0.95)', color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={screenProtector}
                    onClick={() => { setScreenProtector(false)}}
                >
                    <FontAwesomeIcon icon={'fa-sailboat'} size="6x" style={{
                        position:'absolute',
                        fontSize:50,
                        top:logoOffsetY,
                        left:logoOffsetX,
                        transition : 'all 10s ease-in-out',
                        transform : 'translate(-50%, -50%)'
                    }} />
                    {/*<img src={'/branding/anchor.svg'} style={{
                        position:'absolute',
                        top:logoOffsetY,
                        left:logoOffsetX,
                        transition : 'all 10s ease-in-out',
                        width: '150px',
                        height: '150px;',
                        transform : 'translate(-50%, -50%)'
                    }}/>*/}
                </Backdrop>
                <CssBaseline />
                <Grid
                    container
                    xs={false}
                    sm={4}
                    md={7}
                    sx={{
                        backgroundImage: 'url(' + backgroundImage + ')',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',

                    }}
                />
                <Grid  xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                    <Box
                        sx={{
                            my: 8,
                            mx: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap:1
                        }}
                    >
                        <Avatar sx={{bgcolor: 'secondary.main' }}>
                            <LockOutlinedIcon />
                        </Avatar>
                        <Typography component="h1" variant="h4">
                            Sign in
                        </Typography>
                        <Typography component="h2" variant="h6">
                            {(userKey !== null) && (userKey.length > 0) ? (('●').repeat(userKey.length) + ('○').repeat(4-userKey.length)) : '○○○○'}
                        </Typography>

                        <Grid container spacing={1}  display="flex" justifyContent="center" alignItems="center">
                            <Grid ><Button size={'large'} disabled={loginInProgress} onClick={() => keyPress(1)}  variant={"contained"}>1</Button></Grid>
                            <Grid ><Button size={'large'} disabled={loginInProgress} onClick={() => keyPress(2)} variant={"contained"}>2</Button></Grid>
                            <Grid ><Button size={'large'} disabled={loginInProgress} onClick={() => keyPress(3)} variant={"contained"}>3</Button></Grid>
                        </Grid>
                        <Grid container spacing={1}  display="flex" justifyContent="center" alignItems="center">
                            <Grid ><Button size={'large'} disabled={loginInProgress} onClick={() => keyPress(4)} variant={"contained"}>4</Button></Grid>
                            <Grid ><Button size={'large'} disabled={loginInProgress} onClick={() => keyPress(5)} variant={"contained"}>5</Button></Grid>
                            <Grid ><Button size={'large'} disabled={loginInProgress} onClick={() => keyPress(6)} variant={"contained"}>6</Button></Grid>
                        </Grid>
                        <Grid container spacing={1}  display="flex" justifyContent="center" alignItems="center">
                            <Grid ><Button size={'large'} disabled={loginInProgress} onClick={() => keyPress(7)} variant={"contained"}>7</Button></Grid>
                            <Grid ><Button size={'large'} disabled={loginInProgress} onClick={() => keyPress(8)} variant={"contained"}>8</Button></Grid>
                            <Grid ><Button size={'large'} disabled={loginInProgress} onClick={() => keyPress(9)} variant={"contained"}>9</Button></Grid>
                        </Grid>
                        <Grid container  spacing={1}  display="flex" justifyContent="center" alignItems="center">
                            <Grid ><Button size={'large'} disabled={loginInProgress} onClick={backSpace} variant={"outlined"}  color="secondary">
                                <BackspaceOutlinedIcon />
                            </Button></Grid>
                            <Grid ><Button size={'large'} disabled={loginInProgress} onClick={() => keyPress(0)} variant={"contained"}>0</Button></Grid>
                            <Grid>
                                <Button size={'large'} disabled={loginInProgress} onClick={clearCode} variant={"outlined"} color={"error"} >
                                    <ClearOutlinedIcon />
                                </Button>
                            </Grid>
                        </Grid>

                        <LoadingButton
                            mb={2}
                            loading={loginInProgress}
                            size={'large'}
                            variant={"contained"}
                            onClick={handleSubmit}
                            color="success"
                            endIcon={<LoginIcon/>}
                            loadingPosition="end"
                        >
                            Login
                        </LoadingButton>

                        {errorMessage ? (<Alert mt={3} severity="error">{errorMessage}</Alert>) : null}


                    </Box>
                    <Typography style={{fontSize: 10, pointerEvents:'none', textAlign:'center', opacity: 0.4}}>
                        Version 3.5.0
                    </Typography>
                </Grid>
            </Grid>
        );
    }
    return (
        <>
            <Backdrop
                sx={{ color: 'primary', zIndex: (theme) => theme.zIndex.drawer + 2 }}
                open={generalLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Grid container component="main" sx={{ height: '100vh' }}>
                <Grid md={8} container direction="column">
                    <Grid p={0} sx={{ bgcolor: '#cccccc', border: '1px solid grey' }} >
                        <Stack direction="row" spacing={0} useFlexGap flexWrap="wrap" >
                            {(days).map(( day, key) => (
                                    <div key={day.date} style={{padding:5,width:'12.8%'}}>

                                        {/*<Badge badgeContent={day.trips_count} color={"secondary"} fullWidth>*/}

                                        <Button
                                            fullWidth
                                            disabled={tripRequestInProgress.current}
                                            sx={{
                                                height:100
                                            }}
                                            variant={'contained'}
                                            color={(day.date === selectedDate ? 'success' : 'primary')}
                                            onClick={() => {
                                                setSelectedDate(day.date)
                                            }}
                                            focusRipple
                                        >
                                            <Stack>
                                                <Typography variant="subtitle1">
                                                    {day.shortDay}
                                                </Typography>
                                                <Typography variant="subtitle2">
                                                    {day.niceDate}
                                                </Typography>
                                            </Stack>
                                        </Button>
                                        {/*</Badge>*/}
                                    </div>

                                )
                            )}
                        </Stack>
                        {errorMessage ? (<Alert mt={3} variant={'filled'} severity="error">{errorMessage}</Alert>) : null}
                    </Grid>

                    <Grid sx={{ bgcolor: '#ffffff', p: 0, overflowY:'scroll',  border: '1px solid grey'  }} xs={true}>

                        <Backdrop
                            sx={{ color: 'primary', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={loadingDay}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>

                        <Typography variant="h5" align="center" gutterBottom>
                            {dateString}
                        </Typography>

                        <Stack direction="row" spacing={0} useFlexGap flexWrap="wrap"  >
                            {(trips).map(( trip, key) => (
                                    <div key={key} style={{
                                        order: trip.isPast ? 99 : null,
                                        padding:5,
                                        width:'31.8%',

                                    }}>
                                        <Button
                                            sx={/*trip.id == tripID ?  :*/ {
                                                borderWidth: 1,
                                                borderStyle: 'solid',
                                                borderLeftWidth: 10,
                                                borderColor: trip.trip_color ,
                                                background: (trip.id == tripID ? 'success.dark' : trip.trip_color  + '3A'),
                                                color:'#000000',
                                                height:'100%',
                                                alignItems: 'flex-start',

                                                '&:hover' : {
                                                    borderColor: trip.trip_color ,
                                                    borderLeftWidth: 10,
                                                },
                                                '&:active' : {
                                                    borderWidth: 1,
                                                    borderStyle: 'solid',
                                                    borderColor: trip.trip_color ,
                                                    borderLeftWidth: 10,
                                                    borderLeftStyle: 'solid',
                                                }
                                            }}

                                            disabled={trip.isPast}
                                            color={trip.id == tripID ? 'success' : 'secondary'}
                                            variant={trip.id == tripID ? 'contained' : 'outlined'}
                                            onClick={() => {
                                                setTripID(trip.id)
                                            }}
                                            focusRipple
                                        >



                                            <Stack spacing={1}    >
                                                <Typography variant="h4" style={{fontSize:25, fontWeight:'bold'}}>
                                                    {trip.depart_time_nice}
                                                </Typography>
                                                <Typography variant="body2">
                                                    {trip.trip_title}
                                                </Typography>
                                                <Typography variant="body2" style={{opacity:0.5, fontSize:12}}>
                                                    {trip.boat_name}
                                                </Typography>

                                                <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" >
                                                    {!trip.ferry_service  ? (<Chip
                                                        icon={<FontAwesomeIcon icon="fa-ticket"/>}
                                                        style={{paddingLeft: 10}}
                                                        label={trip.passenger_count + '|' + trip.available_space } variant={trip.id == tripID ? 'filled' : 'outlined'} color={"info"} size={'small'} />) : null}

                                                    {trip.ferry_service  ? (<Chip
                                                        icon={<FontAwesomeIcon icon="fa-ticket"/>}
                                                        style={{paddingLeft: 10}}
                                                        label={trip.passengers_outbound + '|' +trip.available_space_outbound } variant={trip.id == tripID ? 'filled' : 'outlined'} color="info" size={'small'} />) : null}
                                                    {trip.ferry_service  ? (<Chip
                                                        icon={<FontAwesomeIcon icon="fa-ticket"/>}
                                                        style={{paddingLeft: 10}}
                                                        label={trip.passengers_inbound + '|' +trip.available_space_inbound} variant={trip.id == tripID ? 'filled' : 'outlined'} color="info" size={'small'} />) : null}

                                                </Stack>
                                                <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" >
                                                    {trip.flags.map(flag => (
                                                        <Chip
                                                            icon={<FontAwesomeIcon icon={"fa-" + flag.icon}/>}
                                                            style={{paddingLeft: 10}}
                                                            label={flag.title } variant='outlined'  size={'small'}
                                                        />
                                                    ))}
                                                </Stack>

                                            </Stack>
                                        </Button>
                                    </div>

                                )
                            )}
                        </Stack>
                    </Grid>
                    {trip !== false && trip.trip_type.ferry_service ? (
                        <Grid container p={1} spacing={0} mb={0} sx={{justifyContent:'space-between', alignItems: 'center'}} >
                            <Grid>
                                <Typography>Journey Type</Typography>
                            </Grid>
                            <Grid>
                                <Button
                                    variant={'contained'}
                                    color={journeyType.id === journeyTypes.outbound.id ? 'warning' : 'primary'}
                                    onClick={() => {
                                        setJourneyType(journeyTypes.outbound)
                                    }}
                                >Outbound Single</Button>
                            </Grid>
                            <Grid>
                                <Button
                                    variant={'contained'}
                                    color={journeyType.id === journeyTypes.return.id ? 'warning' : 'primary'}
                                    onClick={() => {
                                        setJourneyType(journeyTypes.return)
                                    }}
                                >Return</Button>
                            </Grid>
                            <Grid>
                                <Button
                                    variant={'contained'}
                                    color={journeyType.id === journeyTypes.inbound.id ? 'warning' : 'primary'}
                                    onClick={() => {
                                        setJourneyType(journeyTypes.inbound)
                                    }}
                                >Inbound Single</Button>
                            </Grid>
                        </Grid>
                    ) : null}
                    <Grid container mb={0} spacing={0} p={0}>
                        <Grid md={6}>
                            <Box  p={1} backgroundColor={selectedDriver ? '#468eec' : '#cccccc'} >
                                <Stack direction={"row"} alignContent="space-between" spacing={1} mb={0} sx={{justifyContent:'space-between'}} >
                                    <Typography sx={{fontSize:11}}>Coach Driver</Typography>
                                    <Typography sx={{fontSize:11}}>{selectedDriver ? selectedDriver.name : 'None'}</Typography>
                                </Stack>
                            </Box>
                        </Grid>
                        <Grid md={6}>
                            <Box  p={1} backgroundColor={selectedRate ? '#ec4646' : '#cccccc'} >
                                <Stack direction={"row"} alignContent="space-between" spacing={1} mb={0} sx={{justifyContent:'space-between'}} >
                                    <Typography sx={{fontSize:11}}>Rate</Typography>
                                    <Typography sx={{fontSize:11}}>{selectedRate ? selectedRate.label : 'Standard Ticket Pricing'}</Typography>
                                </Stack>
                            </Box>
                        </Grid>
                    </Grid>

                    <Grid p={1}>

                        <Stack direction={'row'} spacing={1}>

                            <Stack direction={'column'} spacing={1}>

                                <Stack direction={'row'} spacing={1}>
                                    <Button variant={'outlined'} onClick={logoutTillUser} color={"secondary"}>Logout</Button>
                                    <DojoTerminalSelector/>
                                    <Button variant={'outlined'} onClick={() => {
                                        initialisePrinter();
                                    }}>
                                        <FontAwesomeIcon icon={'fa-play'} style={{marginRight:5}} />
                                        <FontAwesomeIcon icon={'fa-print'} style={{}} />
                                    </Button>
                                    <Button variant={'contained'} onClick={() => {
                                        reprintReceipt();
                                    }} disabled={(getReceipt === false)}>
                                        <FontAwesomeIcon icon={'fa-rotate-right'} style={{marginRight:5}} />
                                        <FontAwesomeIcon icon={'fa-print'} style={{}} />
                                    </Button>

                                    <Button variant={'contained'} onClick={() => {
                                        createGiftVoucher();
                                    }} disabled={(total > 0 || bookingRef != null)}>
                                        <FontAwesomeIcon icon={'fa-gift'} style={{marginRight:5}} />
                                        {'Create Gift Voucher'}
                                    </Button>


                                    <Button variant={'contained'} onClick={() => {
                                        openPreBookingModal();
                                    }} disabled={(total > 0 || bookingRef != null)}>
                                        <FontAwesomeIcon icon={'fa-flag-checkered'} style={{marginRight:5}} />
                                        {'Prebooked Customers'}
                                    </Button>
                                </Stack>
                                <Stack direction={'row'} spacing={1}>
                                    <Button variant={'contained'} onClick={() => {openCashDraw()}} color={"error"}>Till Drawer</Button>
                                    <Button
                                        variant={"contained"}
                                        color={'warning'}
                                        disabled={(total > 0 || bookingRef != null) }
                                        onClick={() => {
                                            setShowRefundCreatorModal(true);
                                        }}
                                    >Refund Mode</Button>

                                    <Button variant={"contained"} color={'success'}
                                            disabled={(total > 0 || bookingRef != null) }
                                            onClick={() => {
                                                setDriverPayoutModal(true);
                                            }}
                                    >Coach Driver Payout</Button>


                                    <Button variant={"contained"} color={'warning'}
                                            disabled={(total <= 0 || bookingRef == null) || (trip !== false && trip.trip_type.active_custom_trip_rates !== undefined && trip.trip_type.active_custom_trip_rates.length <= 0) }
                                            onClick={() => {
                                                setCustomRateOpen(true);
                                            }}
                                    >Custom Rate</Button>
                                    <Button variant={"contained"} color={'secondary'}
                                            disabled={(total <= 0 || bookingRef == null) }
                                            onClick={() => {
                                                setCoachDriverOpen(true);
                                            }}
                                    >Select Coach Driver</Button>

                                    <Button size={"large"} variant={"contained"} color={"error"} onClick={() => {
                                        cancelBooking()
                                    }}>Cancel Booking</Button>

                                </Stack>
                            </Stack>
                        </Stack>
                    </Grid>
                </Grid>
                <Grid container md={4} direction="column" style={{position:'relative'}} >
                    <Backdrop open={tripLoading} style={{position:'absolute', zIndex:999}}>
                        <CircularProgress color="inherit" />
                    </Backdrop>

                    <Grid>
                        <TripInfo tripData={trip}/>
                    </Grid>

                    <Grid xs={true} >
                        <Stack spacing={1} my={2}>

                            <Grid container spacing={0} gap={2} alignItems={'center'}>
                                <Grid xs="auto">
                                    <IconButton
                                        onClick={()=> {
                                            let newValue = parseInt(adults) -1;
                                            if(newValue <0) {
                                                newValue = 0;
                                            }
                                            setAdults(newValue);
                                        }}
                                        color="primary" aria-label="remove one adult" >
                                        <FontAwesomeIcon icon={'fa-minus-square'} sx={{fontSize:500}} />
                                    </IconButton>
                                </Grid>
                                <Grid xs>
                                    <TextField
                                        size={'small'}
                                        id="outlined-number"
                                        label={'Adults ' + (pricing && pricing.price_per_adult ? ('- £'+ pricing.price_per_adult.toFixed(2)) : '' )}
                                        type="number"
                                        value={adults}
                                        onChange={(event) => {
                                            let newValue = parseInt(event.target.value);
                                            if(newValue === null || !newValue  ) {
                                                newValue = 0;
                                            }
                                            if(newValue < 0 ) {
                                                newValue = 0;
                                            }
                                            setAdults(newValue);

                                        }}

                                    />
                                </Grid>
                                <Grid xs="auto">
                                    <IconButton
                                        onClick={()=> {
                                            let newValue = parseInt(adults);
                                            setAdults(newValue+1);
                                        }}
                                        color="primary"
                                        aria-label="add one adult">
                                        <FontAwesomeIcon icon={'fa-plus-square'} />
                                    </IconButton>
                                </Grid>
                            </Grid>
                            <Grid container spacing={0} gap={2} alignItems={'center'}>
                                <Grid xs="auto">
                                    <IconButton
                                        onClick={()=> {
                                            let newValue = parseInt(children) -1;
                                            if(newValue <0) {
                                                newValue = 0;
                                            }
                                            setChildren(newValue);
                                        }}
                                        color="primary" aria-label="remove one child" >
                                        <FontAwesomeIcon icon={'fa-minus-square'} sx={{fontSize:500}} />
                                    </IconButton>
                                </Grid>
                                <Grid xs>
                                    <TextField
                                        size={'small'}
                                        id="outlined-number"
                                        label={'Children' + (pricing && pricing.price_per_child ? ('- £' + pricing.price_per_child.toFixed(2)) : '')}
                                        type="number"
                                        value={children}
                                        onChange={(event) => {
                                            let newValue = parseInt(event.target.value);
                                            if(newValue === null || !newValue  ) {
                                                newValue = 0;
                                            }
                                            if(newValue < 0 ) {
                                                newValue = 0;
                                            }
                                            setChildren(newValue);

                                        }}

                                    />
                                </Grid>
                                <Grid xs="auto">
                                    <IconButton
                                        onClick={()=> {
                                            let newValue = parseInt(children);
                                            setChildren(newValue+1);
                                        }}
                                        color="primary"
                                        aria-label="add one child">
                                        <FontAwesomeIcon icon={'fa-plus-square'} />
                                    </IconButton>
                                </Grid>
                            </Grid>
                            <Grid container spacing={0} gap={2} alignItems={'center'}>
                                <Grid xs="auto">
                                    <IconButton
                                        onClick={()=> {
                                            let newValue = parseInt(toddlers) -1;
                                            if(newValue <0) {
                                                newValue = 0;
                                            }
                                            setToddlers(newValue);
                                        }}
                                        color="primary" aria-label="remove one toddler" >
                                        <FontAwesomeIcon icon={'fa-minus-square'} sx={{fontSize:500}} />
                                    </IconButton>
                                </Grid>
                                <Grid xs>
                                    <TextField
                                        size={'small'}
                                        id="outlined-number"
                                        label={'Toddlers' + (pricing && pricing.price_per_toddler ? ('- £'+ pricing.price_per_toddler.toFixed(2)) : '' )}
                                        type="number"
                                        value={toddlers}
                                        onChange={(event) => {
                                            let newValue = parseInt(event.target.value);
                                            if(newValue === null || !newValue  ) {
                                                newValue = 0;
                                            }
                                            if(newValue < 0 ) {
                                                newValue = 0;
                                            }
                                            setToddlers(newValue);

                                        }}

                                    />
                                </Grid>
                                <Grid xs="auto">
                                    <IconButton
                                        onClick={()=> {
                                            let newValue = parseInt(toddlers);
                                            setToddlers(newValue+1);
                                        }}
                                        color="primary"
                                        aria-label="add one toddler">
                                        <FontAwesomeIcon icon={'fa-plus-square'} />
                                    </IconButton>
                                </Grid>
                            </Grid>
                            <Grid container spacing={0} gap={2} alignItems={'center'}>
                                <Grid xs="auto">
                                    <IconButton
                                        onClick={()=> {
                                            let newValue = parseInt(families) -1;
                                            if(newValue <0) {
                                                newValue = 0;
                                            }
                                            setFamilies(newValue);
                                        }}
                                        color="primary" aria-label="remove one family" >
                                        <FontAwesomeIcon icon={'fa-minus-square'} sx={{fontSize:500}} />
                                    </IconButton>
                                </Grid>
                                <Grid xs>
                                    <TextField
                                        size={'small'}
                                        id="outlined-number"
                                        label={'Families' + (pricing && pricing.price_per_family ? ('- £' + pricing.price_per_family.toFixed(2)) : '')}
                                        type="number"
                                        value={families}
                                        onChange={(event) => {
                                            let newValue = parseInt(event.target.value);
                                            if(newValue === null || !newValue  ) {
                                                newValue = 0;
                                            }
                                            if(newValue < 0 ) {
                                                newValue = 0;
                                            }
                                            setFamilies(newValue);

                                        }}

                                    />
                                </Grid>
                                <Grid xs="auto">
                                    <IconButton
                                        onClick={()=> {
                                            let newValue = parseInt(families);
                                            setFamilies(newValue+1);
                                        }}
                                        color="primary"
                                        aria-label="add one family">
                                        <FontAwesomeIcon icon={'fa-plus-square'} />
                                    </IconButton>
                                </Grid>
                            </Grid>
                            <Grid container spacing={0} gap={2} alignItems={'center'}>
                                <Grid xs="auto">
                                    <IconButton
                                        onClick={()=> {
                                            let newValue = parseInt(spectators) -1;
                                            if(newValue <0) {
                                                newValue = 0;
                                            }
                                            setSpectators(newValue);
                                        }}
                                        color="primary" aria-label="remove one spectator" >
                                        <FontAwesomeIcon icon={'fa-minus-square'} sx={{fontSize:500}} />
                                    </IconButton>
                                </Grid>
                                <Grid xs>
                                    <TextField
                                        size={'small'}
                                        id="outlined-number"
                                        label={'Spectators'  + (pricing && pricing.price_per_spectator ? ('- £' + pricing.price_per_spectator.toFixed(2)) : '')}
                                        type="number"
                                        value={spectators}
                                        onChange={(event) => {
                                            let newValue = parseInt(event.target.value);
                                            if(newValue === null || !newValue  ) {
                                                newValue = 0;
                                            }
                                            if(newValue < 0 ) {
                                                newValue = 0;
                                            }
                                            setSpectators(newValue);

                                        }}

                                    />
                                </Grid>
                                <Grid xs="auto">
                                    <IconButton
                                        onClick={()=> {
                                            let newValue = parseInt(spectators);
                                            setSpectators(newValue+1);
                                        }}
                                        color="primary"
                                        aria-label="add one sepectator">
                                        <FontAwesomeIcon icon={'fa-plus-square'} />
                                    </IconButton>
                                </Grid>
                            </Grid>
                            <Grid container spacing={0} gap={2} alignItems={'center'}>
                                <Grid xs="auto">
                                    <IconButton
                                        onClick={()=> {
                                            let newValue = parseInt(vips) -1;
                                            if(newValue <0) {
                                                newValue = 0;
                                            }
                                            setVips(newValue);
                                        }}
                                        color="primary" aria-label="remove one vip" >
                                        <FontAwesomeIcon icon={'fa-minus-square'} sx={{fontSize:500}} />
                                    </IconButton>
                                </Grid>
                                <Grid xs>
                                    <TextField
                                        size={'small'}
                                        id="outlined-number"
                                        label='VIPs'
                                        type="number"
                                        value={vips}
                                        onChange={(event) => {
                                            let newValue = parseInt(event.target.value);
                                            if(newValue === null || !newValue  ) {
                                                newValue = 0;
                                            }
                                            if(newValue < 0 ) {
                                                newValue = 0;
                                            }
                                            setVips(newValue);

                                        }}

                                    />
                                </Grid>
                                <Grid xs="auto">
                                    <IconButton
                                        onClick={()=> {
                                            let newValue = parseInt(vips);
                                            setVips(newValue+1);
                                        }}
                                        color="primary"
                                        aria-label="add one vip">
                                        <FontAwesomeIcon icon={'fa-plus-square'} />
                                    </IconButton>
                                </Grid>
                            </Grid>

                        </Stack>
                    </Grid>

                    <Grid>
                        <DojoTerminalErrorNotifcation />
                    </Grid>




                    <Grid>
                        <Box  p={1} backgroundColor={discount > 0 ? '#ffb700' : '#ff9300'} >
                            <Stack direction={"row"} alignContent="space-between" spacing={1} mb={0} sx={{justifyContent:'space-between'}} >
                                <Typography sx={{fontSize:11}}>{'Discount ' + (selectedDiscount ? selectedDiscount.name : '')}</Typography>
                                <Typography sx={{fontSize:11}}>{'£' + discount}</Typography>
                            </Stack>
                        </Box>
                    </Grid>
                    <Grid>
                        <Box  p={1} backgroundColor={'#ff9300'} >
                            <Stack direction={"row"} alignContent="space-between" spacing={1} mb={0} sx={{justifyContent:'space-between'}} >
                                <Typography sx={{fontSize:11}}>Total</Typography>
                                <Typography sx={{fontSize:11}}>£{total.toFixed(2)}</Typography>
                            </Stack>
                            <Typography sx={{fontSize:10}} variant={'h6'}>{bookingRef ? ('Booking Ref : '  + bookingRef) : null}</Typography>
                        </Box>
                    </Grid>

                    <PaymentsMadeEl />

                    <Grid>
                        <Box  p={1} backgroundColor={'#ff5900'} >
                            <Stack direction={"row"} alignContent="space-between" spacing={1} mb={0} sx={{justifyContent:'space-between'}} >
                                <Typography>Due</Typography>
                                <Typography sx={{fontWeight: 'bold'}}>£{(total - amountPaid).toFixed(2)}</Typography>
                            </Stack>
                        </Box>
                    </Grid>



                    <Grid>
                        <Box backgroundColor={'#494949'} p={1}>
                            <Grid container  direction="row" backgroundColor={'#494949'} spacing={1}  mb={1}>
                                <Grid xs={4}>
                                    <Button size={"large"}
                                            color={'warning'}
                                            variant={"contained"}
                                            sx={auxilaryBtnStyle}
                                            disabled={total <= 0 || bookingRef == null}
                                            onClick={() => {
                                                setDiscountsOpen(true);
                                            }}>Discount</Button>
                                </Grid>
                                <Grid xs={8}>
                                    <Button size={"large"} color={'warning'} variant={"contained"}
                                            sx={auxilaryBtnStyle} disabled={total <= 0 || bookingRef == null}
                                            onClick={() => {
                                                setShowGiftVoucherModal(true);
                                            }}
                                    >Gift Voucher</Button>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                                <Grid xs={4}>
                                    <Button
                                        size={"large"}
                                        variant={"contained"}
                                        disabled={bookingRef == null}
                                        sx={paymentMethodBtnStyle}
                                        onClick={() => { payCash() }} >Cash</Button>
                                </Grid>
                                <Grid xs={4}>
                                    <Button size={"large"} variant={"contained"} disabled={total <= 0 || bookingRef == null} sx={paymentMethodBtnStyle} onClick={() => { payCheque() }}>Cheque</Button>
                                </Grid>
                                <Grid xs={4}>
                                    <Button
                                        size={"large"}
                                        variant={"contained"}
                                        disabled={total <= 0 || bookingRef == null}
                                        sx={paymentMethodBtnStyle}
                                        onClick={() => { payCard() }}
                                    >Card</Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

            <Modal open={cashModalOpen}>
                <Box sx={cashModalStyle}>
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={processingCashPayment}
                    >
                        <Stack spacing={2} direction={'column'} alignContent={'center'} justifyContent={'center'}>
                            <LinearProgress color={'inherit'} />
                            <Typography align={'center'}>Processing Cash Payment</Typography>
                        </Stack>
                    </Backdrop>


                    <Typography sx={{fontWeight: 'bold'}} variant={'h4'} align={'right'} mb={3} >Total Remaining: £{(total - amountPaid).toFixed(2)}</Typography>

                    {/*Grid Number Pad*/}
                    <Grid container spacing={2}>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {cashPadPress(1)}} variant={"contained"}>1</Button></Grid>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {cashPadPress(2)}} variant={"contained"}>2</Button></Grid>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {cashPadPress(3)}} variant={"contained"}>3</Button></Grid>

                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {cashPadPress(4)}} variant={"contained"}>4</Button></Grid>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {cashPadPress(5)}} variant={"contained"}>5</Button></Grid>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {cashPadPress(6)}} variant={"contained"}>6</Button></Grid>

                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {cashPadPress(7)}} variant={"contained"}>7</Button></Grid>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {cashPadPress(8)}} variant={"contained"}>8</Button></Grid>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {cashPadPress(9)}} variant={"contained"}>9</Button></Grid>

                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {cashPadPress('back')}} variant={"outlined"}>
                            <BackspaceOutlinedIcon />
                        </Button></Grid>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {cashPadPress(0)}} variant={"contained"}>0</Button></Grid>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {cashPadPress('00')}} variant={"contained"}>00</Button></Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {cashPadPress('total')}} color={'secondary'} variant={"contained"}>Balance</Button></Grid>
                        <Grid xs={true}>
                            <Typography id="modal-modal-title" variant="h4" component="h2" align={'right'} mt={3}>
                                £{cashProvided}
                            </Typography>
                        </Grid>
                    </Grid>



                    <Grid container spacing={2}  mt={2}>
                        <Grid xs={4}>
                            <Button variant={'outlined'} color={'error'} size={'large'} sx={{width:'100%', padding:3}} onClick={() => {
                                setCashProvided(0);
                                setCashModalOpen(false);
                            }}>
                                Cancel
                            </Button>
                        </Grid>
                        <Grid xs={8}>
                            <Button
                                disabled={!cashReady}
                                onClick={() => {
                                    payCashComplete();
                                }}
                                variant={'contained'}
                                color={'success'}
                                size={'large'}
                                sx={{width:'100%', padding:3}}
                            >
                                PAY CASH
                            </Button>
                        </Grid>
                    </Grid>
                </Box>

            </Modal>

            <Modal open={chequeModalOpen}>
                <Box sx={cashModalStyle}>
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={processingChequePayment}
                    >
                        <Stack spacing={2} direction={'column'} alignContent={'center'} justifyContent={'center'}>
                            <LinearProgress color={'inherit'} />
                            <Typography align={'center'}>Processing Cheque Payment</Typography>
                        </Stack>
                    </Backdrop>


                    <Typography sx={{fontWeight: 'bold'}} variant={'h4'} align={'right'} mb={3} >Total Remaining: £{(total - amountPaid).toFixed(2)}</Typography>

                    {/*Grid Number Pad*/}
                    <Grid container spacing={2}>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {chequePadPress(1)}} variant={"contained"}>1</Button></Grid>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {chequePadPress(2)}} variant={"contained"}>2</Button></Grid>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {chequePadPress(3)}} variant={"contained"}>3</Button></Grid>

                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {chequePadPress(4)}} variant={"contained"}>4</Button></Grid>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {chequePadPress(5)}} variant={"contained"}>5</Button></Grid>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {chequePadPress(6)}} variant={"contained"}>6</Button></Grid>

                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {chequePadPress(7)}} variant={"contained"}>7</Button></Grid>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {chequePadPress(8)}} variant={"contained"}>8</Button></Grid>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {chequePadPress(9)}} variant={"contained"}>9</Button></Grid>

                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {chequePadPress('back')}} variant={"outlined"}>
                            <BackspaceOutlinedIcon />
                        </Button></Grid>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {chequePadPress(0)}} variant={"contained"}>0</Button></Grid>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {chequePadPress('00')}} variant={"contained"}>00</Button></Grid>
                    </Grid>

                    <Grid container spacing={2}>
                        <Grid xs={4} ><Button size={'large'} sx={cashBtnStyle} onClick={() => {chequePadPress('total')}} color={'secondary'} variant={"contained"}>Balance</Button></Grid>
                        <Grid xs={true}>
                            <Typography id="modal-modal-title" variant="h4" component="h2" align={'right'} mt={3}>
                                £{chequeProvided}
                            </Typography>
                        </Grid>
                    </Grid>



                    <Grid container spacing={2}  mt={2}>
                        <Grid xs={4}>
                            <Button variant={'outlined'} color={'error'} size={'large'} sx={{width:'100%', padding:3}} onClick={() => {
                                setChequeProvided(0);
                                setChequeModalOpen(false);
                            }}>
                                Cancel
                            </Button>
                        </Grid>
                        <Grid xs={8}>
                            <Button
                                disabled={!cashReady}
                                onClick={() => {
                                    payChequeComplete();
                                }}
                                variant={'contained'}
                                color={'success'}
                                size={'large'}
                                sx={{width:'100%', padding:3}}
                            >
                                PAY CHEQUE
                            </Button>
                        </Grid>
                    </Grid>
                </Box>

            </Modal>

            <Modal open={postBookingModalOpen}>
                <Box sx={cashModalStyle}>
                    <Typography sx={{fontWeight: 'bold'}} variant={'h4'} align={'right'} mb={3} >Change Due: £{changeDue.current.toFixed(2)}</Typography>
                    <Grid container spacing={2}  mt={2}>
                        <Grid xs={12}>
                            <Button
                                onClick={() => {
                                    postBookingReset();
                                }}
                                variant={'contained'}
                                color={'success'}
                                size={'large'}
                                sx={{width:'100%', padding:3}}
                            >
                                OK
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>

            <Backdrop open={processingBooking} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} >
                <Stack spacing={2} direction={'column'} alignContent={'center'} justifyContent={'center'}>
                    <LinearProgress color={'inherit'} />
                    <Typography align={'center'}>Processing Booking</Typography>
                </Stack>
            </Backdrop>

            <Modal open={cardModalOpen}>
                <Box sx={cashModalStyle}>
                    <Typography sx={{fontWeight: 'bold'}} variant={'h4'} align={'right'} mb={3} >Card Payment: £{(total - amountPaid).toFixed(2)}</Typography>
                    <RenderLog log={cardPaymentLog} bgColor={logBg}/>
                    <Typography>{transactionID}</Typography>
                    {transactionResult}
                    <Button
                        variant={'outlined'}
                        color={'error'}
                        size={'large'}
                        sx={{width:'100%', padding:3}}
                        disabled={cardPaymentInProgress}
                        onClick={() => {
                            setCardModalOpen(false);
                            clearCardPaymentVariables();
                        }}>
                        Cancel
                    </Button>
                </Box>
            </Modal>

            <Dialog onClose={() => setCustomRateOpen(false)} open={customRateOpen}>
                <DialogTitle>Select Custom Rate</DialogTitle>
                <List sx={{ pt: 0 }}>
                    <ListItem disableGutters key={'normalRate'}>
                        <ListItemButton
                            selected={selectedRate === false }
                            onClick={() => {
                                setSelectedRate(false);
                                setCustomRateOpen(false);
                            }}
                            xs={{alignItems :'space-between'}}
                            style={{gap: 20}}
                        >
                            <ListItemText primary={'None - Standard Ticket Pricing'} />
                        </ListItemButton>
                    </ListItem>
                    { availableRates.map((rate) => (
                        <ListItem disableGutters key={rate.id}>
                            <ListItemButton
                                selected={rate.id === selectedRate.id }
                                onClick={() => {
                                    setSelectedRate(rate);
                                    setCustomRateOpen(false);
                                }}
                                xs={{alignItems :'space-between'}}
                                style={{gap: 20}}
                            >
                                <ListItemText primary={rate.label} />
                            </ListItemButton>
                        </ListItem>
                    ))
                    }

                </List>

            </Dialog>


            <Dialog onClose={() => setCoachDriverOpen(false)} open={coachDriverOpen}>
                <DialogTitle>Select Coach Driver</DialogTitle>
                {coachDrivers === false ?
                    (  <Box  sx={{

                            width: 300,
                            height: 100,
                        }} >
                            <LinearProgress />
                            <Typography align={"center"} my={2}>Loading Drivers</Typography>
                        </Box>
                    )
                    :
                    (
                        <List sx={{ pt: 0 }}>
                            <ListItem disableGutters key={'no-driver'}>
                                <ListItemButton
                                    selected={selectedDriver === false }
                                    onClick={() => {
                                        setSelectedDriver(false);
                                        setCoachDriverOpen(false);
                                    }}
                                    xs={{alignItems :'space-between'}}
                                    style={{gap: 20}}
                                >
                                    <ListItemText primary={'None'} />
                                </ListItemButton>
                            </ListItem>
                            { coachDrivers.map((driver) => (
                                <ListItem disableGutters key={driver.id}>
                                    <ListItemButton
                                        selected={selectedDriver.id === driver.id }
                                        onClick={() => {
                                            setSelectedDriver(driver);
                                            setCoachDriverOpen(false);
                                        }}
                                        xs={{alignItems :'space-between'}}
                                        style={{gap: 20}}
                                    >
                                        <ListItemText primary={driver.name} />
                                    </ListItemButton>
                                </ListItem>
                            ))
                            }

                        </List>
                    )
                }
            </Dialog>


            <Dialog onClose={() => setDiscountsOpen(false)} open={discountsOpen}>
                <DialogTitle>Select Discount</DialogTitle>
                {availableDiscounts === false ?
                    (  <Box  sx={{

                            width: 300,
                            height: 100,
                        }} >
                            <LinearProgress />
                            <Typography align={"center"} my={2}>Loading Discounts</Typography>
                        </Box>
                    )
                    :
                    (
                        <List sx={{ pt: 0 }}>
                            <ListItem disableGutters key={'no-driver'}>
                                <ListItemButton
                                    selected={selectedDiscount === false }
                                    onClick={() => {
                                        setSelectedDiscount(false);
                                        setDiscountsOpen(false);
                                    }}
                                    xs={{alignItems :'space-between'}}
                                    style={{gap: 20}}
                                >
                                    <ListItemText primary={'None'} />
                                </ListItemButton>
                            </ListItem>
                            { availableDiscounts.map((discountEl) => (
                                <ListItem disableGutters key={discountEl.id}>
                                    <ListItemButton
                                        selected={selectedDiscount.id === discountEl.id }
                                        onClick={() => {
                                            setSelectedDiscount(discountEl);
                                            setDiscountsOpen(false);
                                        }}
                                        xs={{alignItems :'space-between'}}
                                        style={{gap: 20}}
                                    >
                                        <ListItemText primary={discountEl.name} />
                                    </ListItemButton>
                                </ListItem>
                            ))
                            }

                        </List>
                    )
                }
            </Dialog>

            <Modal open={selectDriverForPayoutModalOpen}>
                <Box sx={
                    {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90vw',
                        maxWidth: 800,
                        minHeight:'50vh',
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 1,
                    }
                }>
                    <DialogTitle align={'center'}>Driver Commission Payout</DialogTitle>
                    <Grid container spacing={2}>
                        <Grid md={4}>
                            {coachDrivers === false ?
                                (  <Box  sx={{

                                        width: 300,
                                        maxWidth: '100%',
                                        height: 100,
                                    }} >
                                        <LinearProgress />
                                        <Typography align={"center"} my={2}>Loading Drivers</Typography>
                                    </Box>
                                )
                                :
                                (
                                    <List sx={{ pt: 0, overflowY:'scroll', overflowX:'hidden', width:'100%', maxHeight:'50vh' }}>
                                        { coachDrivers.map((driver) => (
                                            <ListItem disableGutters key={driver.id}>
                                                <ListItemButton
                                                    selected={payoutDriver.id === driver.id }
                                                    onClick={() => {
                                                        setPayoutDriver(driver);
                                                    }}
                                                    xs={{alignItems :'space-between'}}
                                                    style={{gap: 20}}
                                                >
                                                    <ListItemText primary={driver.name} />
                                                </ListItemButton>
                                            </ListItem>
                                        ))
                                        }

                                    </List>
                                )
                            }
                            <Button size={"large"} variant={"contained"} color={"error"} onClick={() => {
                                setPayoutDriver(false);
                                setPayoutData(false);
                                setDriverPayoutModal(false);
                            }}>Cancel</Button>
                        </Grid>
                        <Grid md={8}>

                            {payoutData === false ?
                                (<Typography>{payoutData === false ? 'Please Select a Coach Driver' : ''}</Typography>)
                                :
                                (payoutData ===  'loading' ?
                                    (  <Box  sx={{

                                            width: 300,
                                            height: 100,
                                        }} >
                                            <LinearProgress />
                                            <Typography align={"center"} my={2}>Loading Commission Information</Typography>
                                        </Box>
                                    )
                                    : (
                                        <Box style={{width:'100%'}}>
                                            <Box style={{marginBottom:30, overflowY:'scroll', overflowX:'hidden', width:'100%', maxHeight:'50vh'}}>
                                                <Typography spacing={4} style={{fontWeight: 'bold', marginBottom:30}}>{'Estimated Commission Amount : £' + (payoutData.estimatedPayout.toFixed(2))}</Typography>
                                                {
                                                    payoutData.coachDriver.unpaid_bookings.map((unpaidBooking) => (
                                                        <Grid container spacing={4}>
                                                            <Grid><Typography>{unpaidBooking.booking_ref}</Typography></Grid>
                                                            <Grid xs={4}><Typography align={"right"}>{'£' + unpaidBooking.commission_amount.toFixed(2)}</Typography></Grid>
                                                        </Grid>

                                                    ))
                                                }
                                            </Box>
                                            <Button size={"large"} variant={"contained"} color={"success"}
                                                    disabled={(payoutData.estimatedPayout.toFixed(2) <= 0)}
                                                    onClick={() => {
                                                        processCommissionPayout();
                                                    }}>Process Commission Payment</Button>
                                        </Box>
                                    ))
                            }

                        </Grid>
                    </Grid>
                </Box>
            </Modal>

            <Modal open={showPayoutProcessing}>
                <Box sx={
                    {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90vw',
                        maxWidth: 300,
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 1,
                    }
                }>
                    {payoutAmount === false ?
                        (  <Box  sx={{

                                width: 300,
                                maxWidth: '100%',
                                height: 100,
                            }} >
                                <LinearProgress />
                                <Typography align={"center"} my={2}>Submitting Commission Request</Typography>
                            </Box>
                        )
                        :
                        (
                            <>
                                <Typography sx={{fontWeight: 'bold'}} variant={'h4'} align={'center'} mb={3} >{'Commission Due'}</Typography>
                                <Typography sx={{fontWeight: 'bold'}} variant={'h4'} align={'center'} mb={3} >{'£' + payoutAmount}</Typography>
                                <Button fullWidth={true} size={"large"} variant={"contained"} color={"success"} onClick={() => {
                                    setPayoutDriver(false);
                                    setPayoutData(false);
                                    setPayoutAmount(false);
                                    setShowPayoutProcessing(false);
                                }}>Finish</Button>
                            </>
                        )
                    }
                </Box>
            </Modal>


            <Modal open={showGiftVoucherModal}>
                <Box sx={
                    {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90vw',
                        maxWidth: 800,
                        minHeight:'50vh',
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 1,
                    }
                }>
                    <DialogTitle align={'center'}>Select Gift Voucher</DialogTitle>

                    <Grid container spacing={2}>
                        <Grid md={4}>
                            <TextField id={"giftVoucherSearch"}
                                       label={"Search Gift Vouchers"}
                                       onChange={(event) => {
                                           setGiftVoucherCode(event.target.value);
                                       }}
                            ></TextField>

                            <Typography spacing={4} style={{textAlign:'center', fontWeight: 'bold', marginBottom:30}}>{giftVoucherCode ? 'Matching' : 'Recent'} Gift Vouchers (Max : 20)</Typography>
                            {giftVouchers === false ?
                                (  <Box  sx={{

                                        width: 300,
                                        maxWidth: '100%',
                                        height: 100,
                                    }} >
                                        <LinearProgress />
                                        <Typography align={"center"} my={2}>Loading Gift Vouchers</Typography>
                                    </Box>
                                )
                                :
                                (
                                    <List sx={{ pt: 0, overflowY:'scroll', overflowX:'hidden', width:'100%', maxHeight:'50vh' }}>
                                        { giftVouchers.map((giftVoucherEl) => (
                                            <ListItem disableGutters key={giftVoucherEl.id}>
                                                <ListItemButton
                                                    selected={false}
                                                    onClick={() => {
                                                        setGiftVoucher(giftVoucherEl);
                                                    }}
                                                    xs={{alignItems :'space-between'}}
                                                    style={{gap: 20}}
                                                >
                                                    <ListItemText primary={giftVoucherEl.code} />
                                                    <ListItemText primary={'£' + giftVoucherEl.amount.toFixed(2)} />
                                                </ListItemButton>
                                            </ListItem>
                                        ))
                                        }

                                    </List>
                                )
                            }
                            <Button size={"large"} variant={"contained"} color={"error"} onClick={() => {
                                resetGiftVoucherModal();
                            }}>Cancel</Button>
                        </Grid>
                        <Grid md={8}>

                            {giftVoucher === false ?
                                (<Typography spacing={4} style={{fontWeight: 'bold', marginBottom:30}}>{giftVoucher === false ? 'Please Select Gift Voucher' : ''}</Typography>)
                                :
                                (giftVoucher ===  'loading' ?
                                    (  <Box  sx={{

                                            width: 300,
                                            height: 100,
                                        }} >
                                            <LinearProgress />
                                            <Typography align={"center"} my={2}>Loading Gift Voucher Information</Typography>
                                        </Box>
                                    )
                                    : (
                                        <Box style={{width:'100%'}}>
                                            <Box style={{marginBottom:30, overflowY:'scroll', overflowX:'hidden', width:'100%', maxHeight:'50vh'}}>
                                                <Typography spacing={4} style={{fontWeight: 'bold', marginBottom:30}}>{'Gift Voucher Code : ' + (giftVoucher.code)}</Typography>
                                                <Typography spacing={4} style={{fontWeight: 'bold', marginBottom:30}}>{'Gift Voucher Code : £' + (giftVoucher.amount.toFixed(2))}</Typography>

                                            </Box>
                                            <Button size={"large"} variant={"contained"} color={"success"}
                                                    onClick={() => {
                                                        addGiftVoucher(giftVoucher);
                                                    }}>Add Gift Voucher to Booking</Button>
                                        </Box>
                                    ))
                            }

                        </Grid>
                    </Grid>
                </Box>
            </Modal>

            <Modal open={showGiftVoucherCreatorModal}>
                <Box sx={
                    {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90vw',
                        maxWidth: 800,
                        minHeight:'50vh',
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 1,
                    }
                }>
                    <DialogTitle align={'center'}>Create Gift Voucher</DialogTitle>

                    <Grid container spacing={2}>
                        <Grid md={4}>
                            <TextField id={"giftVoucherAmount"}
                                       label={"Gift Voucher Amount"}
                                       value={newGiftVoucherAmount}
                                       type={"number"}
                                       fullWidth={true}
                                       onChange={(event) => {
                                           if(event.target.value.length > 0)
                                           {
                                               setNewGiftVoucherAmount(Math.abs(parseFloat(event.target.value)));
                                           } else  {
                                               setNewGiftVoucherAmount('');
                                           }
                                       }}
                                       style={{marginBottom:20}}
                                       InputProps={{
                                           startAdornment: <InputAdornment position="start">£</InputAdornment>,
                                       }}
                            >
                            </TextField>

                            <Button disabled={newGiftVoucherProcessing} variant={'contained'} size={'large'} fullWidth={true} style={{marginBottom:20}}
                                    onClick={() => {
                                        setNewGiftVoucherAmount(5)
                                    }}>£5</Button>
                            <Button disabled={newGiftVoucherProcessing} variant={'contained'} size={'large'} fullWidth={true} style={{marginBottom:20}}
                                    onClick={() => {
                                        setNewGiftVoucherAmount(10)
                                    }}>£10</Button>
                            <Button disabled={newGiftVoucherProcessing} variant={'contained'} size={'large'} fullWidth={true} style={{marginBottom:20}}
                                    onClick={() => {
                                        setNewGiftVoucherAmount(20)
                                    }}>£20</Button>
                            <Button disabled={newGiftVoucherProcessing} variant={'contained'} size={'large'} fullWidth={true} style={{marginBottom:20}}
                                    onClick={() => {
                                        setNewGiftVoucherAmount(50)
                                    }}>£50</Button>


                            <Button disabled={newGiftVoucherProcessing} fullWidth={true} size={"large"} variant={"contained"} color={"error"} onClick={() => {
                                resetGiftVoucherCreator();
                            }}>Cancel</Button>
                        </Grid>
                        <Grid md={4} style={{borderRadius:5, borderWidth: 1, borderColor: '#cccccc', borderStyle:'solid'}}>
                            <Text style={{fontSize:20,marginBottom:20,}}>Amount : £{newGiftVoucherAmount ? newGiftVoucherAmount.toFixed(2) : '-'}</Text>
                            <Button fullWidth={true} size={"large"} color={"secondary"} style={{marginBottom:20}}
                                    variant={newGiftVoucherPaymentMethod == 'card' ? "contained" : 'outlined'}
                                    disabled={newGiftVoucherProcessing || newGiftVoucherAmount <= 0}
                                    onClick={() => { setNewGiftVoucherPaymentMethod('card')}}>Card</Button>

                            <Button fullWidth={true} size={"large"} color={"secondary"} style={{marginBottom:20}}
                                    variant={newGiftVoucherPaymentMethod == 'cash' ? "contained" : 'outlined'}
                                    disabled={newGiftVoucherProcessing || newGiftVoucherAmount <= 0}
                                    onClick={() => { setNewGiftVoucherPaymentMethod('cash')}}>Cash</Button>

                            <Typography  style={{fontSize:20,marginBottom:20,}} >Payment Method : {newGiftVoucherPaymentMethod}</Typography>
                            <Button disabled={newGiftVoucherProcessing || newGiftVoucherAmount <= 0} fullWidth={true} size={"large"} variant={"contained"} color={"success"} onClick={() => {
                                processNewGiftCardRequest();
                            }}>Pay and Generate</Button>
                        </Grid>
                        <Grid md={4} style={{borderRadius:5, borderWidth: 1, borderColor: '#cccccc', borderStyle:'solid'}}>
                            {newGiftVoucherProcessing ? (
                                <Box  sx={{

                                    maxWidth: 300,
                                    width:'100%',
                                    height: 100,
                                }} >
                                    <LinearProgress />
                                    <Typography align={"center"} my={2}>Processing Gift Voucher Request</Typography>
                                </Box>

                            ): null}
                            {newGiftVoucherProcessing && newGiftVoucherPaymentMethod === 'card' ? ( <RenderLog log={newGiftVoucherTerminalLog} bgColor={'#000000'}/>) : null}
                            {!newGiftVoucherProcessing && newGiftVoucherComplete && newGiftVoucher ? (
                                <>
                                    <Typography  style={{fontSize:20,marginBottom:20,}} >Gift Voucher Code : {newGiftVoucher.code}</Typography>
                                    <Typography  style={{fontSize:20,marginBottom:20,}} >Gift Voucher Amount : £{newGiftVoucher.amount.toFixed(2)}</Typography>
                                    <Button fullWidth={true} size={"large"} variant={"contained"} color={"success"} onClick={() => {
                                        resetGiftVoucherCreator();
                                    }}>Finish</Button>
                                </>
                            ) : null}
                            {newGiftVoucherTransactionResult}
                            {newGiftVoucherError ? (
                                <>
                                    <Typography  style={{fontSize:20,marginBottom:20,}} >Error Creating Gift Card</Typography>
                                    <Typography  style={{fontSize:20,marginBottom:20,}} >{newGiftVoucherError}</Typography>
                                    <Button fullWidth={true} size={"large"} variant={"contained"} color={"success"} onClick={() => {
                                        resetGiftVoucherCreator();
                                    }}>Finish</Button>
                                </>

                            ) : null}
                        </Grid>
                    </Grid>
                </Box>
            </Modal>


            <Modal open={showRefundCreatorModal}>
                <Box sx={
                    {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90vw',
                        maxWidth: 800,
                        minHeight:'50vh',
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 1,
                    }
                }>
                    <DialogTitle align={'center'}>CREATE REFUND</DialogTitle>

                    <Grid container spacing={2}>
                        <Grid md={4}>
                            <TextField id={"refundAmount"}
                                       label={"Refund Amount"}
                                       value={refundAmount}
                                       type={"number"}
                                       fullWidth={true}
                                       onChange={(event) => {
                                           if(event.target.value.length > 0) {
                                               setRefundAmount(Math.abs(parseFloat(event.target.value)));
                                           } else {
                                               setRefundAmount('');
                                           }
                                       }}
                                       style={{marginBottom:20}}
                                       InputProps={{
                                           startAdornment: <InputAdornment position="start">£</InputAdornment>,
                                       }}
                            >
                            </TextField>
                            <TextField id={"refundNote"}
                                       label={"Refund Note"}
                                       value={refundNote}
                                       rows={4}
                                       maxRows={4}
                                       fullWidth={true}
                                       multiline={true}
                                       onChange={(event) => {
                                           setRefundNote(event.target.value);
                                       }}
                                       style={{marginBottom:20}}
                            >
                            </TextField>
                            <Text>Min Length - 10 Characters</Text>

                            <Button disabled={refundProcessing} fullWidth={true} size={"large"} variant={"contained"} color={"error"} onClick={() => {
                                resetRefundCreator();
                            }}>Cancel</Button>

                        </Grid>
                        <Grid md={4} style={{borderRadius:5, borderWidth: 1, borderColor: '#cccccc', borderStyle:'solid'}}>
                            <Text style={{fontSize:20,marginBottom:20,}}>Amount : £{refundAmount ? refundAmount.toFixed(2) : '-'}</Text>
                            <Button fullWidth={true} size={"large"} color={"secondary"} style={{marginBottom:20}}
                                    variant={refundPaymentMethod == 'card' ? "contained" : 'outlined'}
                                    disabled={refundProcessing || refundAmount <= 0}
                                    onClick={() => { setRefundPaymentMethod('card')}}>Card</Button>

                            <Button fullWidth={true} size={"large"} color={"secondary"} style={{marginBottom:20}}
                                    variant={refundPaymentMethod == 'cash' ? "contained" : 'outlined'}
                                    disabled={refundProcessing || refundAmount <= 0}
                                    onClick={() => { setRefundPaymentMethod('cash')}}>Cash</Button>

                            <Typography  style={{fontSize:20,marginBottom:20,}} >Payment Method : {newGiftVoucherPaymentMethod}</Typography>
                            <Button disabled={refundProcessing || refundAmount <= 0 || refundNote.length <= 10} fullWidth={true} size={"large"} variant={"contained"} color={"success"} onClick={() => {
                                processRefundRequest()
                            }}>Generate Refund</Button>
                        </Grid>
                        <Grid md={4} style={{borderRadius:5, borderWidth: 1, borderColor: '#cccccc', borderStyle:'solid'}}>
                            {refundProcessing ? (
                                <Box  sx={{

                                    maxWidth: 300,
                                    width:'100%',
                                    height: 100,
                                }} >
                                    <LinearProgress />
                                    <Typography align={"center"} my={2}>Processing Refund</Typography>
                                </Box>

                            ): null}
                            {refundProcessing && refundPaymentMethod === 'card' ? ( <RenderLog log={refundTerminalLog} bgColor={'#000000'}/>) : null}
                            {!refundProcessing && refundComplete && refund ? (
                                <>
                                    <Typography  style={{fontSize:20,marginBottom:20,}} >Amount : £{refund.amount.toFixed(2)}</Typography>
                                    <Button fullWidth={true} size={"large"} variant={"contained"} color={"success"} onClick={() => {
                                        resetRefundCreator();
                                    }}>Finish</Button>
                                </>
                            ) : null}
                            {refundTransactionResult}
                            {refundError ? (
                                <>
                                    <Typography  style={{fontSize:20,marginBottom:20,}} >Error Creating Refund</Typography>
                                    <Typography  style={{fontSize:20,marginBottom:20,}} >{refundError}</Typography>
                                    <Button fullWidth={true} size={"large"} variant={"contained"} color={"success"} onClick={() => {
                                        resetRefundCreator();
                                    }}>Finish</Button>
                                </>

                            ) : null}
                        </Grid>
                    </Grid>
                </Box>
            </Modal>


            {/*    PRE Booked Bookings elements*/}
            <Modal open={showPreBookedBookingsModal}>
                <Box sx={
                    {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90vw',
                        maxWidth: 1000,
                        minHeight:'80vh',
                        maxHeight:'80vh',
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        //overflowY:'scroll',
                        p: 1,
                    }
                }>
                    <DialogTitle align={'center'}>Pre Booked Bookings</DialogTitle>
                    <Box sx={
                        {
                            maxHeight:'60vh',
                            overflowY:'scroll',
                        }
                    }>
                    {loadingPreBookedBookings ?
                        (
                            <Stack spacing={2} direction={'column'} alignContent={'center'} justifyContent={'center'}>
                                <LinearProgress color={'inherit'} />
                                <Typography align={'center'}>Fetching Booking List</Typography>
                            </Stack>
                        ) : (prebookedBookings).map((booking, key) => (
                                <Box sx={{borderBottom: '1px solid #cccccc', padding: 2}}>
                                    <Grid container spacing={2}>
                                        <Grid md={2}>
                                            <Typography variant={'h6'}>{booking.booking_ref}</Typography>
                                            <Typography>{booking.trip.niceDate}</Typography>
                                        </Grid>
                                        <Grid md={4}>
                                            <Typography variant={'h6'} style={{fontSize:16}}>{booking.customer.name}</Typography>
                                            <Typography style={{fontSize:13}}>{booking.public_notes_plain.substring(0,100)}...</Typography>

                                        </Grid>
                                        <Grid md={4}>
                                            <Typography variant={'h6'} style={{fontSize:15}}>{booking.trip.trip_type.name}</Typography>
                                            <Typography style={{fontSize:13}}>{booking.trip.depart_time ?? '??'}</Typography>
                                            <Typography style={{fontSize:13}}>{booking.trip.depart.name ?? '??'}</Typography>

                                        </Grid>
                                        <Grid md={2} >
                                            <Typography
                                                variant={'h6'}
                                                style={{
                                                    marginBottom:20
                                                }}
                                            >{('£' + booking.outstanding.toFixed(2)) ?? '-'}</Typography>
                                            <Button
                                                size={"large"}
                                                fullWidth={true}
                                                variant={"contained"}
                                                color={"success"}
                                                onClick={() => {
                                                    openPrebookingActionModal(booking);
                                                }}
                                            >Select</Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            )
                        )
                    }
                    </Box>

                    <Button
                        style={{marginTop:20}}
                        fullWidth={true}
                        size={"large"}
                        variant={"contained"}
                        disabled={(loadingPreBookedBookings || processingPreBookedBookings)}
                        color={"error"} onClick={() => {
                        closePreBookingModal();
                    }}>Close</Button>

                </Box>
            </Modal>

            <Modal open={showPreBookedBookingActionModal}>
                <Box sx={
                    {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90vw',
                        maxWidth: 1000,
                        minHeight:300,
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        overflowY:'scroll',
                        p: 1,
                    }
                }>
                    {!prebookedBooking ? (
                        <Stack spacing={2} direction={'column'} alignContent={'center'} justifyContent={'center'}>
                            <LinearProgress color={'inherit'} />
                            <Typography align={'center'}>Fetching Booking</Typography>
                        </Stack>
                    ) : (
                        <>
                            <DialogTitle align={'center'}>{prebookedBooking.booking_ref} - {prebookedBooking.customer.name}</DialogTitle>
                            <Typography style={{fontSize:14, marginBottom:20}}>{prebookedBooking.public_notes_plain}</Typography>
                            <Grid container spacing={2}>
                                <Grid md={4}>

                                    <Typography >{'Adults : ' + (prebookedBooking.num_adults ?? '-')}</Typography>
                                    <Typography >{'Children : ' + (prebookedBooking.num_children ?? '-')}</Typography>
                                    <Typography >{'Toddlers : ' + (prebookedBooking.num_toddlers ?? '-')}</Typography>
                                    <Typography >{'Spectators : ' + (prebookedBooking.num_spectators ?? '-')}</Typography>
                                    <Typography >{'VIPs : ' + (prebookedBooking.num_vips ?? '-')}</Typography>
                                </Grid>
                                <Grid md={4}>
                                    <Typography>Total : £{prebookedBooking.total_price.toFixed(2)}</Typography>
                                    <Typography>Outstanding : £{prebookedBooking.outstanding.toFixed(2)}</Typography>
                                </Grid>
                                <Grid md={4}>

                                    <Button
                                        fullWidth={true}
                                        size={"large"}
                                        variant={"contained"}
                                        disabled={prebookedBooking.outstanding <= 0}
                                        onClick={() => {
                                            openPrebookingPaymentModal();
                                        }}
                                    >Pay Outstanding Balance</Button>

                                    <Button
                                        fullWidth={true}
                                        style={{marginTop:20}}
                                        size={"large"}
                                        variant={"contained"}
                                        color={"success"}
                                        onClick ={() => {
                                            if(prebookedBooking.outstanding > 0) {
                                                if(window.confirm('This booking has an outstanding balance are you sure you want to print the tickets anyway?')) {
                                                    printPrebookedTickets(prebookedBooking);
                                                }
                                            } else {
                                                printPrebookedTickets(prebookedBooking);
                                            }
                                        }}

                                    >Print Tickets</Button>
                                </Grid>
                            </Grid>
                        </>

                    )}




                    <Button
                        style={{marginTop:20}}

                        size={"large"}
                        variant={"contained"}
                        disabled={(loadingPreBookedBookings || processingPreBookedBookings)}
                        color={"error"} onClick={() => {
                        closePrebookingActionModal();
                    }}>Close</Button>
                </Box>
            </Modal>

            <Modal open={showPreBookedBookingPaymentModal}>
                <Box sx={
                    {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90vw',
                        minHeight:'50vh',
                        maxWidth: 1000,
                        padding:3,
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                    }
                }>
                    {!prebookedBooking ? (
                        <Stack spacing={2} direction={'column'} alignContent={'center'} justifyContent={'center'}>
                            <Typography align={'center'}>Booking Info not found</Typography>
                        </Stack>
                    ) : (
                        <>
                            <DialogTitle align={'center'}>{prebookedBooking.booking_ref} - {prebookedBooking.customer.name}</DialogTitle>
                            <Grid container spacing={0}>
                                <Grid md={4} p={2} style={{borderRadius:5, borderWidth: 1, borderColor: '#cccccc', borderStyle:'solid'}}>

                                    <Typography >{'Adults : ' + (prebookedBooking.num_adults ?? '-')}</Typography>
                                    <Typography >{'Children : ' + (prebookedBooking.num_children ?? '-')}</Typography>
                                    <Typography >{'Toddlers : ' + (prebookedBooking.num_toddlers ?? '-')}</Typography>
                                    <Typography >{'Spectators : ' + (prebookedBooking.num_spectators ?? '-')}</Typography>
                                    <Typography >{'VIPs : ' + (prebookedBooking.num_vips ?? '-')}</Typography>
                                    <Typography>Total : £{prebookedBooking.total_price.toFixed(2)}</Typography>
                                    <Typography>Outstanding : £{prebookedBooking.outstanding.toFixed(2)}</Typography>
                                </Grid>
                                <Grid md={4} p={2} style={{borderRadius:5, borderWidth: 1, borderColor: '#cccccc', borderStyle:'solid'}}>

                                    <Button
                                        fullWidth={true}
                                        size={"large"}
                                        color={"secondary"}
                                        style={{marginBottom:20}}
                                        variant={prebookingPaymentMethod == 'card' ? "contained" : 'outlined'}
                                        disabled={prebookingPaymentInProgress}
                                        onClick={() => { setPrebookingPaymentMethod('card')}}>Card</Button>

                                    <Button
                                        fullWidth={true}
                                        size={"large"}
                                        color={"secondary"}
                                        style={{marginBottom:20}}
                                        variant={prebookingPaymentMethod == 'cash' ? "contained" : 'outlined'}
                                        disabled={prebookingPaymentInProgress}
                                        onClick={() => { setPrebookingPaymentMethod('cash')}}>Cash</Button>

                                    <Typography  style={{fontSize:20,marginBottom:20,}} >Payment Method : {prebookingPaymentMethod}</Typography>
                                    <Button disabled={prebookingPaymentInProgress}
                                            fullWidth={true}
                                            size={"large"}
                                            variant={"contained"}
                                            color={"success"}
                                            onClick={() => {
                                                processPrebookingPayment();
                                            }}
                                    >Make Payment</Button>

                                </Grid>
                                <Grid md={4} p={2} style={{borderRadius:5, borderWidth: 1, borderColor: '#cccccc', borderStyle:'solid'}}>

                                    {prebookingPaymentInProgress ? (
                                        <Box  sx={{

                                            maxWidth: 300,
                                            width:'100%',
                                            height: 100,
                                        }} >
                                            <LinearProgress />
                                            <Typography align={"center"} my={2}>Processing Payment Request</Typography>
                                        </Box>

                                    ): null}
                                    {prebookingPaymentInProgress && prebookingPaymentMethod === 'card' ? ( <RenderLog log={prebookingTerminalLog} bgColor={'#000000'}/>) : null}
                                    {!prebookingPaymentInProgress && prebookingComplete && !prebookingError ? (
                                        <>
                                            <Button fullWidth={true} size={"large"} variant={"contained"} color={"success"} onClick={() => {
                                                closePrebookingPaymentModal();
                                            }}>Finish</Button>
                                        </>
                                    ) : null}
                                    {prebookingTransactionResult}
                                    {prebookingError ? (
                                        <>
                                            <Typography  style={{fontSize:20,marginBottom:20,}} >Error Submitting Payment</Typography>
                                            <Typography  style={{fontSize:20,marginBottom:20,}} >{prebookingError}</Typography>
                                            <Button fullWidth={true} size={"large"} variant={"contained"} color={"success"} onClick={() => {
                                                closePrebookingPaymentModal();
                                            }}>Finish</Button>
                                        </>

                                    ) : null}

                                </Grid>
                            </Grid>
                        </>

                    )}




                    <Button
                        style={{marginTop:20}}
                        fullWidth={true}
                        size={"large"}
                        variant={"contained"}
                        disabled={(prebookingPaymentInProgress)}
                        color={"error"} onClick={() => {
                        closePrebookingPaymentModal();
                    }}>Close</Button>
                </Box>
            </Modal>

        </>

    );
}


